(function ($) {
  // Selector Picker
  var selectorPicker = {
    url: 'https://s3.amazonaws.com/shopify-apps/Plugins/SelectorPicker/selector-picker.js',
    cmd: 'sign=wholesale-pricing-membership-manager'
  };
  // do nothing for not-logged customer
  if (typeof SWPMMParams == 'undefined' && document.location.search.indexOf(selectorPicker.cmd) === -1) {
    return;
  }

  var Shopify = Shopify || {};

  var formatMoney = function(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var value = '';

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
      return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
  }

  Shopify.formatMoney = formatMoney;

  /**
   * Return:
   *  0   - version1 = version2
   *  -1  - version1 < version2
   *  1   - version1 > version2
   */
  var versionCompare = function (version1, version2) {
    function normalize (version) {
      return jQuery.map(version.split('.'), function (value) {
        return parseInt(value, 10);
      });
    }

    version2 = version2 || $.fn.jquery;
    if (version1 == version2) {
      return 0;
    }
    var v1 = normalize(version1);
    var v2 = normalize(version2);
    var len = Math.max(v1.length, v2.length);
    for (var i = 0; i < len; i++) {
      v1[i] = v1[i] || 0;
      v2[i] = v2[i] || 0;
      if (v1[i] == v2[i]) {
        continue;
      }
      return v1[i] > v2[i] ? 1 : -1;
    }
    return 0;
  };

  var loadScript = function (url, callback) {
    loadAsset('script', 'text/javascript', url, callback);
  };

  var loadAsset = function (elementName, type, url, callback) {

    var script = document.createElement(elementName);
    if (elementName == 'script') {
      script.src = url;
    } else if (type == 'text/css') {
      script.rel = 'stylesheet';
      script.media = 'all';
      script.href = url;
    }

    script.type = type;

    // If the browser is Internet Explorer.
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
      // For any other browser.
    } else {
      script.onload = function () {
        callback();
      };
    }

    document.getElementsByTagName('head')[0].appendChild(script);
  };

  var main = function ($, baseJquery) {
    var jQuery = $;

    var Config = (function (storeConfig) {
      var config = $.extend({
        s3Prefix: '//s3.amazonaws.com/shopify-apps/wholesaleprices',
        cart_product_price: 'td [class=\'tt-price\']',
        cart_product_subtotal: '.CartItem__Price',
        cart_first_product_subtotal: '.CartItem__PriceList .CartItem__Price:first-of-type',
        cart_product_wrapper: '.CartItem__Wrapper',
        cart_subtotal: '#subtotal .value',
        cart_total: '#grandtotal .value',
        productPricesSelector: '.Price:not(.Price--compareAt):not(.CartItem__Price)',
        message_container: 'nav.main',
        productForm: 'form[action="/cart/add"]',
        addToCartEvent: 'click',
        addToCartButton: '[type=submit]',
        productContainer: 'body',
        variantSelect: '.single-option-selector',
        variantNativeSelect: '[name=id]',
        initTimeout: 0,
        insertAfter: '[data-order-summary-section="payment-lines"]',
        frameHeight: '500px',
        allowedCountries: ['US', 'BY', 'PT', 'PL'],
        customerVipTag: 'vip',
        customerWholesaleTag: 'wholesale',
        creditsInputSelector: '#vipStoreCreditsInput input[name="creditsValue"]',
        creditsMaxSelector: '#vipStoreCreditsInput input[name="creditsMax"]',

        customerVipRemovedTag: 'vip_removed',
        customerVipSubscriptionLabel: 'VIP subscription',
        customerVipSubscriptionCost: 29,
        orderUsedCreditsAttribute: 'Used VIP Credits',
        orderBalanceCreditsAttribute: 'Initial User VIP Balance',
        firstVipPricePostfix: ' VIP',
        disableAppParams: {
          'feed': 'google'
        },

        vipCheckoutPageUrl: '/pages/checkout',
        vipCartWidgetCheckoutText: 'Agree & Continue',
        cartForm: 'form[action="/cart"]',
        checkoutUrl: '/checkout',

        s3SharedPrefix: 'https://vip.madamglam.com/files/upload',
        apiUrl: 'https://vip.madamglam.com',
        draft_orders_api: 'https://vip.madamglam.com/files/upload/js/rest-proxy.js',
        debugString: '',
        vipProductVid: 22282723754042,
        vipFreeShipping: 2219651760186,
        excludeScripts: ['198803519']
      }, storeConfig);
      return {
        init: function () {
          config = $.extend(config, SWPMMSettings);
        },
        get: function (key, subset) {
          if (key && subset) {
            return config[subset][key];
          } else {
            return config[key] || null;
          }
        },
        set: function (key, value, subset) {
          subset = subset || false;
          if (key && subset) {
            return config[subset][key] = value;
          } else {
            return config[key] = value;
          }
        },
        getCartAttrName: function () {
          return this.get('cart_attr_name') ? this.get('cart_attr_name') : 'Member Prices';
        },
        getCartQuantitySelector: function (id) {
          var selector = Config.getCustom('cartQuantitySelector', '[id^=\'updates_:id\']');
          selector = (selector.indexOf(':id') !== -1) ? selector.replace(':id', id) : selector;

          return config['selector_prefix'] ? config['selector_prefix'] + selector : selector;
        },
        getCustom: function (key, defaultValue) {
          if (typeof (defaultValue) == 'undefined') {
            defaultValue = false;
          }

          return (typeof (SWPMMCustom) !== 'undefined' && typeof (SWPMMCustom[key]) !== 'undefined') ? SWPMMCustom[key] : defaultValue;
        },
        getZipcodeCookie: function () {
          return this.getCookie(config.zipcodeCookieName);
        },
        setZipcodeCookie: function (zipcode) {
          this.setCookie(config.zipcodeCookieName, zipcode);
        },
        setCookie: function (key, value, expirationInterval) {
          var expires = new Date();
          expirationInterval = expirationInterval || 10000 * 60 * 60 * 1000;// default = 1 hour
          expires.setTime(expires.getTime() + expirationInterval);
          document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
        },
        getCookie: function (key) {
          var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
          return keyValue ? keyValue[2] : null;
        },
        getHash: function () {
          if (Config.get('hash')) {
            return Config.get('hash');
          }
          return Config.get('id');
        }
      };
    })(SWPMMParams);

    $.fn.serializeObject = function () {
      // todo cm-591 refactoring this method for a separate class
      var self = this,
        json = {},
        push_counters = {},
        patterns = {
          'validate': /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
          'key': /[a-zA-Z0-9_]+|(?=\[\])/g,
          'push': /^$/,
          'fixed': /^\d+$/,
          'named': /^[a-zA-Z0-9_]+$/
        };

      this.build = function (base, key, value) {
        base[key] = value;
        return base;
      };

      this.push_counter = function (key) {
        if (push_counters[key] === undefined) {
          push_counters[key] = 0;
        }
        return push_counters[key]++;
      };

      $.each($(this).serializeArray(), function () {

        // Skip invalid keys
        if (!patterns.validate.test(this.name)) {
          return;
        }

        var k,
          keys = this.name.match(patterns.key),
          merge = this.value,
          reverse_key = this.name;

        while ((k = keys.pop()) !== undefined) {

          // Adjust reverse_key
          reverse_key = reverse_key.replace(new RegExp('\\[' + k + '\\]$'), '');

          // Push
          if (k.match(patterns.push)) {
            merge = self.build([], self.push_counter(reverse_key), merge);
          }

          // Fixed
          else if (k.match(patterns.fixed)) {
            merge = self.build([], k, merge);
          }

          // Named
          else if (k.match(patterns.named)) {
            merge = self.build({}, k, merge);
          }
        }

        json = $.extend(true, json, merge);
      });

      return json;
    };

    var App = function () {//base object
      var self = this;
      this.customer = {};
      this.custom_order = {};

      this.init = function () {
        Config.init();
        this.customer = SWPMMParams.customer;
        this.setOptions();
        // if (this.customer.id){
        //     if ( !this.isTaggedCustomer() ) {
        //         return false;
        //     }
        // }else{
        //     this.showMessage();
        // }
      };

      this.setOptions = function () {
        // setup options
        Spurit.prices.setOptions({
          format: Config.get('moneyFormat'),
          // for multicurrencies - not used yet
          // formats: {},
          // prefix: 'data',
          // selector: '#currencies'
        });
      };

      this.reloadPage = function () {
        location.reload(true);
      };

      this.getActiveTags = function () {
        var tags = [];
        if (SWPMMTags) {
          tags = Object.keys(SWPMMTags);
        }

        return tags;
      };

      this.getTagSettings = function () {
        if (this.customer.tags !== null && this.customer.tags.indexOf(Config.get('customerWholesaleTag')) !== -1)
          return SWPMMTags[Config.get('customerWholesaleTag')];

        return SWPMMTags[Config.get('customerVipTag')];
      };

      this.isTaggedCustomer = function () {
        // var membershipTags = this.getActiveTags();

        this.customer.tagSettings = this.getTagSettings();
        this.customer.isVipRemoved = this.isVipRemovedCustomer();
        // if (!this.customer.id){
        //     return true;
        // }

        // var tagsCount = this.customer.tags.length;
        // for (var i = 0; i<tagsCount; i++) {
        //     var customerTag = this.customer.tags[i];
        //     if ( membershipTags.indexOf(customerTag) > -1 ) {
        //         this.customer.tag = customerTag;
        //         this.customer.tagSettings = this.getTagSettings(customerTag);
        //         // this.showMessage();
        //         return true;
        //     }
        // }
        return true;
      };

      this.isVipCustomer = function () {
        if (!this.customer.id) {
          return false;
        }

        return this.customer.tags.indexOf(Config.get('customerVipTag')) > -1;
      };

      this.isWholesaleCustomer = function () {
        if (!this.customer.id) {
          return false;
        }

        return this.customer.tags.indexOf(Config.get('customerWholesaleTag')) > -1;
      };

      this.isVipRemovedCustomer = function () {
        if (!this.customer.id) {
          return false;
        }

        return this.customer.tags.indexOf(Config.get('customerVipRemovedTag')) > -1;
      };

      this.getVipStoreCredits = function () {
        let storeCredits = 0;
        self.customer.metafields.forEach(function (item) {
          if (item[0] === 'balance') {
            storeCredits = item[1] / 100;
          }
        });
        return storeCredits;
      };

      this.showMessage = function () {
        if ($('#SWPMM-message').length) {
          return;
        }
        var target = $(Config.get('message_container') + ':first');
        var position = Config.get('message_container_position');
        var enabled = false;
        if (this.customer.id) {
          var tagSettings = this.customer.tagSettings;

          var discount = (tagSettings.discount_type == 'fixed')
            ? Spurit.prices.formatMoney(tagSettings.discount * 100)
            : tagSettings.discount + '%';
          var name = this.customer.name;
          var type = ((tagSettings.products.constructor !== Array || tagSettings.collections.constructor !== Array) ? 'some' : 'all');
          var message = (type == 'some') ? Config.get('text_some_products') : Config.get('text_all_products');
          var color = (type == 'some') ? Config.get('color_some_products') : Config.get('color_all_products');
          enabled = (type == 'some') ? Config.get('enable_some_products') : Config.get('enable_all_products');
          message = message.replace(/:username/g, name);
          message = message.replace(/:discount_condition/g, discount);
        } else {
          var message = Config.get('text_not_registered');
          var color = Config.get('color_not_registered');
          enabled = Config.get('enable_not_registered');
        }

        if (target.length && parseInt(enabled)) {
          var messageBox = $('<div id="SWPMM-message" style="background-color: ' + color + '">' + message + '</div>');
          switch (position) {
            case 'after':
              target.after(messageBox);
              break;
            case 'before':
              target.before(messageBox);
              break;
            case 'inside':
              target.append(messageBox);
              break;

            default:
          }
        }
      };

      this.isProductTagged = function (product, collections) {
        // if (!this.customer.id) {
        //     return false;
        // }
        // var tagSettings = this.getTagSettings(Config.get('customerVipTag'));
        // if ( tagSettings.products.constructor === Array && tagSettings.collections.constructor === Array ) {
        //     return false;
        // }
        // var result = false;
        // result = this.isAllowedProduct(product);
        // if ( !result ) {
        //     result = this.isAllowedCollection(collections);
        // }

        // if (!this.isVipCollection(product.handle)) {
        //   return false;
        // }

        return this.isAllowedCollection(collections);
      };

      this.isAllowedProduct = function (product) {
        var tagSettings = this.getTagSettings(this.customer.tag);
        if (tagSettings.products.constructor !== Array) {
          if (tagSettings.products[product.id]) {
            var targetProduct = tagSettings.products[product.id];
            if (targetProduct.variants.indexOf('' + product.vid) > -1) {
              return true;
            }
          }
        }

        return false;
      };

      /**
       * @param productCollections array of collection objects
       */
      this.isAllowedCollection = function (productCollections) {
        var tagSettings = this.getTagSettings();
        if (tagSettings.collections.constructor !== Array) {
          var targetCategories = Object.keys(tagSettings.collections);

          var pcLength = productCollections.length;
          for (var i = 0; i < pcLength; i++) {
            var collection = productCollections[i];
            if (targetCategories.indexOf('' + collection.id) > -1) {
              return true;
            }
          }
        }

        return false;
      };

      /**
       *
       * @param product
       * @param element
       * @returns {$}
       */
      this.isBundleDiscount = function (product) {
        var res = product ? product.tags.includes('bundle-party') : $('.bundle-party').length;
        return res && $('*[data-discount-type="bundle-party"]').length;
      };

      /**
       *
       * @param cartItems
       * @returns {undefined}
       */
      this.getBundleDiscountSubtotal = function(cartItems) {
        var checkoutTotal = window.SWPMMParams.cartSubtotal;
        if(self.isBundleDiscount()) {
          var discountValue = 0;

          for(var id in cartItems) {
            if(cartItems.hasOwnProperty(id)) {
              for(var i = 0; i < SWPMMParams.items.length; i++) {
                if (id*1 === SWPMMParams.items[i].id*1 && self.isBundleDiscount(SWPMMParams.items[i].product)) {
                  discountValue += cartItems[id].discountValue;
                  break;
                }
              }
            }
          }
          checkoutTotal -= discountValue;
        }
        return checkoutTotal;
      }

      /**
       *
       * @param element
       * @returns {false}
       */
      this.isBundleDiscountProduct = function(element) {
        var parentElement = element.parentNode
        var elDataAttr = parentElement.closest('*[data-discount-type="bundle-party"]');
        return parentElement.classList.contains('bundle-party') && elDataAttr;
      }

      this.renewBundlePrice = function () {
        $('.bundle-party').each(function (index, element) {
          var price = $(element).find('.sp-price:visible .money').text();
          if (price) {
            var cPriceCont = $(element).find('.CartItem__Price:not(.sp-price)');
            cPriceCont.text(price);
            var currentPrice = parseInt(price.replace(/[^\d;]/g, '').trim());
            var originalPrice = parseInt($(element).attr('data-original'));
            if (currentPrice && originalPrice > currentPrice) {
              cPriceCont.after('<span class="CartItem__OriginalPrice Price Text--subdued Price--compareAt remove-with-reset">' + Spurit.prices.formatMoney(originalPrice) + '</span>');
              cPriceCont.addClass('Price--highlight');
            }
          }
        });
      };

      /**
       *
       * @param enabled
       */
      this.setBundleDiscountLoader = function (enabled) {
        if (this.isBundleDiscount()) {
          var node = $('#vipOrderLoading');
          enabled ? node.addClass('is-active') : node.removeClass('is-active');
        }
      };

      /**
       *
       * @param url
       * @returns {boolean}
       */
      this.renderBundleDiscounts = function (url) {
        if (!this.isBundleDiscount()) {
          return false;
        }

        var type = self.isVipCustomer() ? 'vip-price' : parseInt($('#cartVipWidget input:checked').val()) ? 'vip-price' : '';
        var addParams = this.AjaxAddProps(SWPMMParams.items[0], 0, type, this.discounted_lines);
        $.when(addParams).done(function () {
          self.getCheckoutData(url, true, function (res) {
            self.parseDiscounts(res, false);
            self.setBundleDiscountLoader(false);
          }, function (err) {
            console.error(err);
            self.setBundleDiscountLoader(false);
          });
        });
        return true;
      };

      /**
       *
       * @param callback
       * @returns {boolean}
       */
      this.refreshBundleDiscounts = function (callback) {
        if (!this.isBundleDiscount()) {
          return false;
        }
        if (typeof callback === 'undefined') {
          callback = function () {};
        }

        this.getCheckoutData('/checkout', true, function (res) {
          self.parseDiscounts(res, false);
          callback();
          self.setBundleDiscountLoader(false);
        }, function (err) {
          console.error(err);
          self.setBundleDiscountLoader(false);
        });
        return true;
      };

      /**
       *
       * @param enabled
       */
      this.renderBundleDiscountPrice = function (enabled) {
        if (this.isBundleDiscount()) {
          var node = $('.bundle-party');
          enabled ? node.removeClass('is-hidden') : node.addClass('is-hidden');
        }
      };

      /**
       *
       * @param type
       */
      this.reNewBundleDiscountProps = function (type) {
        if (this.isBundleDiscount()) {
          var callback = type ? function () {} : function () {
            Spurit.resetVipPrices();
            if (self.getVipStoreCredits() && !self.isContainGiftCardProduct) {
              self.showVipCreditsInput();
            }
          }
          var addParams = self.AjaxAddProps(SWPMMParams.items[0], 0, type, self.discounted_lines);
          $.when(addParams).done(function () {Spurit.refreshCart(callback);});
        }
      };

      /**
       *
       */
      this.redrawCommonDiscountPrices = function (isVip) {
        let $$priceTotals = $('.CartItem__Price:not(.sp-price):not(.Price--compareAt)');
        self.shopifyCart.items.forEach(function (item,index) {
          if ($$priceTotals.length < self.shopifyCart.items.length && $$priceTotals.length <= index) {
            //if autoadded element don't issue in list of items in DOM
            return;
          }
          if (item.discounts.length > 0) {
            let isAvailableForVip = false;
            item.discounts.forEach(function (discount) {
              if (self.isDiscountAvailable(discount.title)) {
                isAvailableForVip = true;
              }
            });
            if(!isAvailableForVip) {
              let totalPrice = isVip ? $$priceTotals[index].parentElement.dataset.original : $$priceTotals[index].parentElement.dataset.final;
              $$priceTotals[index].textContent = Shopify.formatMoney(totalPrice);
            }
          }
        });
      };

      /**
       *
       * @param items
       */
      this.excludeBundleVariants = function(items) {
        var tmp = [];

        if(self.isBundleDiscount() && items) {
          for (var id in items){
            if(items.hasOwnProperty(id)) {
              for(var i = 0; i < SWPMMParams.items.length; i++) {
                if (id*1 === SWPMMParams.items[i].id*1 && self.isBundleDiscount(SWPMMParams.items[i].product)) {
                  tmp.push(id*1);
                  break;
                }
              }
            }
          }
        }
        return tmp;
      }

      /**
       *
       * @param onSuccess
       * @param onError
       */
      this.forceClearCart = function (onSuccess, onError) {
        $.ajax({
          type: 'POST',
          url: '/cart/clear.js',
          success: function () {
            onSuccess();
          },
          error: function () {
            onError();
          },
          dataType: 'json'
        });
      };

      /**
       *
       * @param data
       * @param callback
       */
      this.forceAddDataToCart = function (data, callback) {
        $.ajax({
          type: 'POST',
          data: data,
          url: '/cart/add.js',
          success: function () {
            console.log('add product in cart');
            callback();
          },
          error: function () {
            console.log('fail add product in cart');
            callback();
          },
          dataType: 'json'
        });
      };

      /**
       *
       * @param name
       */
      this.delete_cookie = function (name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      };

      /**
       *
       */
      this.clearCartAfterLogout = function () {
        var excludeProperties = ['first', 'second', 'third', '_freeUS', 'shipping_boxes'];

        $('a[href="/account/logout"]').on('click', function (e) {
          e.preventDefault();

          $.getJSON('/cart.json').success(function (cart) {
            var cartItems = cart.items;

            if (cartItems.length) {
              var newCartItems = { items: [] };

              for (var i = 0; i < cartItems.length; i++) {
                var hasExcludeOption = false;
                for (var j = 0; j < excludeProperties.length; j++) {
                  if (cartItems[i].properties.hasOwnProperty(excludeProperties[j])) {
                    hasExcludeOption = true;
                    break;
                  }
                }
                if (!hasExcludeOption) {
                  newCartItems.items.push({
                    id: cartItems[i].variant_id,
                    quantity: cartItems[i].quantity
                  });
                }
              }
              self.forceClearCart(function () {
                self.delete_cookie('cart');
                if (newCartItems.items.length) {
                  self.forceAddDataToCart(newCartItems, function() {
                    window.location.replace('/account/logout');
                  });
                }
              }, function() {
                console.error('Cart not removed');
                window.location.replace('/account/logout');
              });
            } else {
              window.location.replace('/account/logout');
            }
          }).fail(function(){
            console.error('Bad request to cart.json');
            window.location.replace('/account/logout');
          });
        });
      };

      /**
       * Checks if product is included in at least
       * one collection in selected in App Settings (in VIP membership)
       * @returns {boolean}
       */
      this.isVipCollection = function (product_handle) {
        var tagSettings = this.customer.tagSettings;
        for (var key in tagSettings.collections) {
          if (typeof isIncludedInCollections === 'undefined') {
            var isIncludedInCollections = false;
          }
          if (
            tagSettings.collections.hasOwnProperty(key) &&
            typeof SWPMMParams.productsWithCollections[product_handle] !== 'undefined' &&
            SWPMMParams.productsWithCollections[product_handle].collections.includes(parseInt(key))
          ) {
            isIncludedInCollections = true;
            break;
          }
        }

        return typeof isIncludedInCollections === 'undefined' || isIncludedInCollections === true;
      };

      /**
       * Get product price from snippet
       *
       * @param product_handle
       * @returns bool | int
       */
      this.getProductPrice = function (product_handle) {
        if (!SWPMMParams.productsWithCollections.hasOwnProperty(product_handle)) {
          return false;
        }
        return SWPMMParams.productsWithCollections[product_handle].price;
      };

      /**
       *
       * @param product_handle
       * @returns bool
       */
      this.isFirstVipTag = function (product_handle) {
        if (!SWPMMParams.productsWithCollections.hasOwnProperty(product_handle)) {
          return false;
        }
        return SWPMMParams.productsWithCollections[product_handle].first_vip_tag;
      };

      this.getHandleFromUrl = function (url) {
        return /[^/]*$/.exec(url.split('?')[0])[0];
      };

      this.updatePrices = function () {
        Spurit.isDraftOrder = true;
        if ($(Config.get('cart_subtotal')).hasClass('sp-price')) {
          return false;
        }
        if (!Spurit.isDiscountApply) {
          if (self.getVipStoreCredits() && !self.isContainGiftCardProduct) {
            self.showVipCreditsInput();
          }
          Spurit.prices.recalculate('total', Config.get('cartSubtotal'), function () {
          });
          self.displayItemPrices();
        }
        Spurit.isDiscountApply = false;
      };

      this.resetPrices = function () {
        $('#vipDiscount').addClass('is-hidden');
        Spurit.isDraftOrder = false;
        let newCheckoutTotal = $('#subtotal .value').attr('data-newcheckouttotal');
        if (newCheckoutTotal !== undefined) {
          newCheckoutTotal = newCheckoutTotal.trim();
        } else {
          newCheckoutTotal = '0';
          $('#undefinedNewTotal').remove();
          $('#grandtotal').after('<div id="undefinedNewTotal" style="color: red">Some problem with calculate Total</div>');
          console.warn('Attribute newcheckouttotal = ', newCheckoutTotal);
        }
        var grandtotal = self.deleteMoneyFormat(newCheckoutTotal);
        if (typeof self.discount_to_subtotal !== 'undefined' && !isNaN(self.discount_to_subtotal)) {
          grandtotal -= self.discount_to_subtotal;
        }

        if(grandtotal) {
          var saveMoney = SWPMMParams.cartSubtotal - grandtotal;
          if (saveMoney) {
            var tmpMoney = '-' + Shopify.formatMoney(saveMoney);
            $('#zeroVipDiscount .value').text(tmpMoney);
            $('#zeroVipDiscount').removeClass('is-hidden');
          } else {
            $('#zeroVipDiscount').addClass('is-hidden');
          }
        }

        if (typeof Spurit.vipCreditsToUse !== 'undefined') {
          var inputVal = self.deleteMoneyFormat($(Config.get('creditsInputSelector')).val());
          grandtotal -= inputVal;
        }
        $('#grandtotal .value').text(Shopify.formatMoney(grandtotal));
        // if(!$('#cartVipWidget').length && $('#discountCode').hasClass('is-visible')) {
        //     $('#discountCode').removeClass('is-visible');
        // }

        if(self.isBundleDiscount()) {
          $('.remove-with-reset').each(function (index, element) {
            $(element).remove();
          });

          $('.bundle-party .CartItem__Price.Price--highlight:not(.sp-price)').each(function (index, element) {
            $(element).removeClass('Price--highlight');
          })
        }
        self.renewBundlePrice();

        var $$priceElements = $(Config.get('cart_product_price') + ', ' + Config.get('cart_product_subtotal') + ', ' + Config.get('cart_subtotal') + ', ' + Config.get('cart_total'));
        $$priceElements.each(function (index, element) {
          $(element).attr('style', '').siblings('.sp-price').remove();
        });
        if(!self.isBundleDiscount()) {
          $('.remove-with-reset').each(function (index, element) {
            $(element).remove();
          });
        }
        //hot fix for excludeScripts(don't show discount for line-item on VIP tab) and items without VIP prices.
        //show compareAt prices on PAYG tab
        if(Config.get('excludeScripts').indexOf(window.SWPMMParams.scriptId) !== -1) {
          $('.CartItem__OriginalPrice').attr('style','');
        }
      };

      this.calcNewPrice = function (price) {
        var tagSettings = self.customer.tagSettings;
        var discount = tagSettings.discount;
        var newPrice = price;

        // apply Vip Balance Discount

        if (discount && tagSettings.discount_type == 'percent') {
          newPrice = price - price * discount / 100;
        } else if (discount) {
          newPrice = (parseFloat(price) / 100 - discount) * 100;
        }
        if (newPrice < 0) {
          newPrice = price;
        } else {
          if (tagSettings.enabled_round && tagSettings.round_up) {
            newPrice = (Math.floor(parseFloat(newPrice) / 100) + '.' + tagSettings.round_up) * 100;
          }
        }

        return Math.ceil(newPrice);
      };

      this.calcNewFirstPrice = function (price) {
        var tagSettings = self.customer.tagSettings;
        var discount = parseFloat(tagSettings.first_discount);
        var newPrice = price;

        // apply Vip Balance Discount

        if (discount && tagSettings.first_discount_type == 'percent') {
          newPrice = price - price * discount / 100;
        } else if (discount) {
          newPrice = (discount > parseFloat(price) / 100) ? parseFloat(price) / 100 : discount;
          newPrice *= 100;
        }
        if (newPrice < 0) {
          newPrice = price;
        } else {
          if (tagSettings.enabled_round && tagSettings.round_up) {
            newPrice = (Math.floor(parseFloat(newPrice) / 100) + '.' + tagSettings.round_up) * 100;
          }
        }

        return Math.ceil(newPrice);
      };

      this.setStyle = function (el, name, val) {
        if (el.style[name] !== undefined) {
          el.setAttribute('data-initial-style-' + name, el.style[name]);
        }
        if (val.indexOf('!important') === -1) {
          el.style[name] = val;
        } else {
          el.style.cssText += ';' + name + ':' + val;
        }
      };
      //don't touch this, ever!
      this.getCheckoutItem = function (html) {
        var productId, variantId, quantity, oldPrice, newPrice, discountValue, discount, oldPriceString, newPriceString,
          discountsLines, firstNewPrice, firstQuantity;
        var discountCode = $(html).find('.order-summary__section .tags-list .reduction-code__text').text();
        var checkoutItems = $(html).find('table tr[class="product"]');
        var parseArray = [];
        checkoutItems.each(function () {
          discountValue = 0;
          firstNewPrice = -1; //newprice for 1-st line-item auto-discount product
          firstQuantity = 0;
          productId = $(this).data('productId');
          variantId = $(this).data('variantId');
          discountsLines = $(this).find('.reduction-code .reduction-code__text');
          if (typeof parseArray[variantId] !== 'undefined') {
            firstNewPrice = parseArray[variantId].newPrice;
            firstQuantity = parseArray[variantId].quantity;
          }

          oldPriceString = $(this).find('td[class="product__price"] del').text().trim();
          newPriceString = $(this).find('td[class="product__price"] .order-summary__emphasis').text().trim();
          newPrice = newPriceString === 'Free' ? 0 : self.deleteMoneyFormat(newPriceString);
          quantity = $(this).find('.product-thumbnail__quantity').text().trim();
          oldPrice = oldPriceString ? self.deleteMoneyFormat(oldPriceString) : newPrice;
          discountValue += self.discountValue(discountsLines, discountCode,2);
          discount = discountValue / oldPrice;
          parseArray[variantId] = {
            'productId': productId,
            'variantId': variantId,
            'oldPrice': oldPrice,
            'newPrice': newPrice,
            'quantity': parseInt(quantity),
            'discount': discount,
            'discountValue': discountValue,
            'firstNewPrice': firstNewPrice,
            'firstQuantity': firstQuantity
          };
        });
        return parseArray;
      };
      //calculate discount for line-item without discount code/only with discount code
      this.discountValue = function (discountsLines, code, without = true) {
        var discountValue = 0;
        var allDiscountValue = 0;
        discountsLines.each(function () {
          var line = $(this).text();
          var arr = line.split('(').map(function (item) {
            return item.trim();
          });
          allDiscountValue += self.deleteMoneyFormat(arr[1]);
          if (arr[0] !== code && without) {
            if (self.isDiscountAvailable(arr[0])) {
              if (typeof (without) === 'number') {
                discountValue = allDiscountValue;
              } else {
                discountValue += self.deleteMoneyFormat(arr[1]);
              }
            }
          }
          if (arr[0] === code && !without) {
            discountValue += self.deleteMoneyFormat(arr[1]);
          }
        });
        return discountValue;
      };

      //get only fixed amount discounts
      this.getAvailableCartDiscount = function (html) {
        var cartDiscountElement = $(html).find('.order-summary__section .total-line--reduction[data-discount-type="fixed_amount"]');
        var cartDiscount = {};
        if (cartDiscountElement.length) {
          cartDiscount = {
            code: cartDiscountElement[0].querySelector('.reduction-code__text').textContent,
            amount: cartDiscountElement[0].querySelector('[data-checkout-discount-amount-target]').dataset.checkoutDiscountAmountTarget
          }
        }
        return cartDiscount;
      }

      this.isDiscountAvailable = function (code) {
        code = code.toUpperCase();
        var result = false;
        if (SWPMMDiscounts) {
          if (SWPMMDiscounts.indexOf(code) != -1) {
            result = true;
          }
        }
        return result;
      };

      this.getCheckoutData = function (url, async, onSuccess, onError) {
        if (typeof async === 'undefined') {
          async = false;
        }
        if (typeof onSuccess === 'undefined') {
          onSuccess = function () {};
        }
        if (typeof onError === 'undefined') {
          onError = function () {};
        }
        var checkoutUrl = url;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', checkoutUrl, async);

        xhr.onload = function (e) {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              onSuccess(xhr.responseText);
            } else {
              onError(xhr.statusText);
            }
          }
        };

        xhr.onerror = function (e) {
          onError(xhr.statusText);
        };

        xhr.send();
        return xhr.responseText;
      };

      this.deleteMoneyFormat = function (price) {
        return parseInt(parseFloat(price.replace(/[\$,\-\(\)]/g, '') * 100).toFixed());
      };

      this.checkVipShippingIs = function (hasToBeAdded, callback = () => {
      }) {
        callback();
        return true;
        if (typeof hasToBeAdded === 'undefined') {
          hasToBeAdded = true;
        }
        $.ajax({
          type: 'GET',
          url: '/cart.json',
          success: function (data) {
            self.callbackCheckVipShippingIs(hasToBeAdded, data, callback);
          },
          dataType: 'json'
        });
      };

      this.callbackCheckVipShippingIs = function (hasToBeAdded, data, callback = () => {
      }) {
        var numOfVipFreeShippingProducts = 0,
          vipProductVid = Config.get('vipProductVid'),
          actionUrl = '',
          actionData = { 'id': vipProductVid };

        data.items.every(function (item) {
          if (typeof item.variant_id === 'undefined' || item.variant_id !== vipProductVid) {
            return true;
          }
          numOfVipFreeShippingProducts++;
          return true;
        });

        if (!hasToBeAdded) {
          if (numOfVipFreeShippingProducts > 0) {
            // remove VIP product
            actionUrl = '/cart/change.js';
            actionData.quantity = 0;
          }
        } else {
          if (numOfVipFreeShippingProducts === 0) {
            // add VIP product
            actionUrl = '/cart/add.js';
          } else if (numOfVipFreeShippingProducts > 1) {
            // set only one VIP product
            actionUrl = '/cart/change.js';
            actionData.quantity = 1;
          }
        }

        if (actionUrl) {
          try {
            $.ajax({
              type: 'POST', url: actionUrl,
              data: actionData, async: false, dataType: 'json',
              success: function () {
                callback();
              },
              error: function (xhr, ajaxOptions, thrownError) {
                callback();
              },
            });
          } catch (e) {
            callback();
          }
        } else {
          callback();
        }
      };

      this.loadingStart = function (clickElement) {
        if (clickElement) {
          $(clickElement).prop('disabled', true);
        }
        $('body').addClass('no-scroll');
        $('#vipOrderLoading').addClass('is-active');
      };

      this.loadingEnd = function (clickElement) {
        $('body').removeClass('no-scroll');
        $('#vipOrderLoading').removeClass('is-active');
        if (clickElement) {
          $(clickElement).prop('disabled', false);
        }
      };

      this.checkGoogleFeed = function () {
        let searchStr = this.parseUrlQuery();
        for (let prop in Config.get('disableAppParams')) {
          if(searchStr.hasOwnProperty(prop)) {
            document.cookie = 'disable_vip_app=1; Path=/;';
          }
        }
      }

      this.parseUrlQuery = function () {
        var data = {};
        if(location.search) {
          var pair = (location.search.substring(1)).split('&');
          for(var i = 0; i < pair.length; i ++) {
            var param = pair[i].split('=');
            data[param[0]] = param[1];
          }
        }
        return data;
      }

      Spurit.showAlert = function (text) {
        $('body').addClass('no-scroll')
          .append('<div class="popup is-visible"><div class="popup-content">' + text + '<a href="#" class="close-style"><span></span></a></div></div>');
      };

      Spurit.hideAlert = function () {
        $('body.no-scroll').removeClass('no-scroll');
        $('.popup.is-visible').removeClass('is-visible');
      };

      $(document).keyup(function (event) {
        //check if user has pressed 'Esc'
        if (event.which === 27) {
          Spurit.hideAlert();
        }
      });

      $('body').on('click', '.popup', function (e) {
        e.preventDefault();
        if ($(e.target).is('.popup')) {
          Spurit.hideAlert();
        }
      }).on('click', '.close-style', function (e) {
        e.preventDefault();
        Spurit.hideAlert();
      });
    };

    var CartPage = function () {
      var self = this;
      this.shopifyCart = {};
      this.gift_card = {};
      this.discount_code = {};
      this.auto_discound_amount = 0;
      this.discount_to_subtotal = 0;
      this.discounted_lines = '';
      this.firstVipVid = 0;
      this.originalTagSettingsDiscount = '';

      App.apply(this, arguments);//inherit app constructor

      this.discountedVariants = [];
      this.isContainGiftCardProduct = false;
      this.init = function () {
        try {
        Config.init();
        this.customer = SWPMMParams.customer;
        this.setOptions();
        this.initPriceUpdater();

        this.createVipWidget();

        if (!this.isVipCustomer() ||
          typeof this.customer.shipping_address === 'undefined' ||
          !this.customer.shipping_address ||
          this.customer.shipping_address.country !== 'United States'
        ) {
          self.checkVipShippingIs(false);
        } else {
          self.checkVipShippingIs(true);
        }

        if (!this.isTaggedCustomer()) {
          return false;
        }

        window.addEventListener('beforeunload', function () {
          console.log('disable cache');
        });

        //get cart with free shipping from braintree
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          async: false,
          dataType: 'json',
          success: function (cart) {
            self.shopifyCart = cart;
            if(SWPMMParams.scriptId === '109576255') {
              self.blackFridayDiscount();
            }
          }
        });

        this.setDiscountedVariants(SWPMMParams.items);

        if (!this.isVipCustomer()) {
          if (self.shopifyCart.items.length) {
            var iteration = self.shopifyCart.items.length > 5 ? 5 : self.shopifyCart.items.length;
            for (var i = 0; i < iteration; i++) {   //2 if cart has vip-free-shipping
              if (self.shopifyCart.items[i].properties !== 'undefined' && self.shopifyCart.items[i].properties !== null) {
                if (self.shopifyCart.items[i].properties.hasOwnProperty('vip-prop') && self.shopifyCart.items[i].properties['vip-prop'] === 'vip-price') {
                  self.AjaxAddProps(self.shopifyCart.items[i], i);
                }
              }
            }
          }

          $(Config.get('cartForm')).submit(function (e) {
            e.preventDefault();
            loadingStart();
            window.location.href = '/checkout';
          });
        }

        $('#vipCheckout').on('click touch', function (e) {
          e.preventDefault();
          loadingStart();

          self.checkVipShippingIs(true, () => {
            if (SWPMMParams.items.length) {
              var addFreeProduct = true;
              if (typeof window.autoDiscount !== 'undefined') {
                addFreeProduct = (typeof window.autoDiscount.active.nameScript !== 'undefined') ? self.addFreeProduct() : true;
              }
              $.when(addFreeProduct).then(function (data) {
                $.getJSON('/cart.json').then(function (cart) {
                  var items = cart.items;
                  var addParams = self.AjaxAddProps(items[0], 0, 'vip-price', self.discounted_lines);
                  var addAttr = self.addCreditsAttr();
                  $.when(addParams, addAttr).done(function () {
                    console.log('Cart and params update');
                    self.goToVipCheckout();
                  });
                });
              });
            }
          });

        });

        $('body').on('click', '#discountCodeSubmit', function (e) {
          e.preventDefault();
          var discountSubmit = $('#discountCodeSubmit');
          var discountCodeValue = $('#discountCodeInput').val();
          self.discount_to_subtotal = 0;
          Spurit.isDiscountApply = true;
          $('.warning').text('');
          if (discountCodeValue === '') {
            return false;
          }
          $(discountSubmit).attr('disabled', 'disabled');
          setTimeout(function () {
            $(discountSubmit).removeAttr('disabled');
          }, 100);
          var url = '/checkout?discount=' + discountCodeValue;
          var res = self.getCheckoutData(url);
          self.parseDiscounts(res, false);
          if (!self.isVipCustomer()) {
            var isVipSelect = parseInt($('#cartVipWidget input:checked').val());
            if (!isVipSelect) {
              Spurit.resetVipPrices();
            }
          }
        });

        $(document).on('cart:refreshed', function () {
          self.refreshCart(function (){
            console.log('callback refreshCart dispatch');
            document.dispatchEvent(new CustomEvent('cart:quantityUpdated'))
          });
        });

        this.clearCartAfterLogout();

        self.redrawCommonDiscountPrices(true);
        self.setBundleDiscountLoader(true);
        Spurit.applyVipPrices();
        var url = '/checkout';

        setTimeout(function ajax1 () {
          if (!self.renderBundleDiscounts(url)) {
            //get checkout data only after all extra changes on cart page
            let intervalId = setInterval(() => {
              if(!Shopify.queueWorking) {
                clearInterval(intervalId);
                var res = self.getCheckoutData(url);
                self.parseDiscounts(res, false);
                $('#vipOrderLoading').removeClass('is-active');
                if (Config.getCookie('disable_vip_app')) {
                  $('#isNotVip').click();
                }
                self.setBundleDiscountLoader(false);
              }
            }, 100);
          }
        }, 250);
        }
        catch (e) {
          console.log(e);
          Sentry.captureException(e);
        }
      };

      this.refreshCart = function (callback) {
        if (typeof callback === 'undefined') {
          callback = function () {};
        }
        self.setBundleDiscountLoader(true);
        self.discountedVariants = [];
        self.isContainGiftCardProduct = false;
        self.discounted_lines = '';
        self.discount_to_subtotal = 0;
        $.when(
          $.ajax({ type: 'GET', url: '/cart.js', dataType: 'json' }),
          $.ajax({ type: 'GET', url: '/cart?view=spurit_madamvip-ajax-params', dataType: 'html' })
        ).done(function (ajaxCart, vipParams) {
          self.shopifyCart = ajaxCart[0];
          vipParams = JSON.parse(vipParams[0]);
          SWPMMParams = Object.assign(SWPMMParams, vipParams);
          Config.set('cartSubtotal', SWPMMParams.cartSubtotal);
          if(SWPMMParams.scriptId === '109576255') {
            self.blackFridayDiscount();
          }
          self.setDiscountedVariants(SWPMMParams.items);
          if (!self.refreshBundleDiscounts(callback)) {
            var res = self.getCheckoutData('/checkout');
            self.parseDiscounts(res, false);
            $('#vipOrderLoading').removeClass('is-active');
            callback();
          }
        });
      };

      this.blackFridayDiscount = function () {
        if(SWPMMParams.itemsCount >= 10) {
          if (!this.originalTagSettingsDiscount.length) {
            this.originalTagSettingsDiscount = SWPMMParams.customer.tagSettings.discount;
          }
          SWPMMParams.customer.tagSettings.discount = "60.00";
        } else {
          if (this.originalTagSettingsDiscount.length > 0) {
            SWPMMParams.customer.tagSettings.discount = this.originalTagSettingsDiscount;
            this.originalTagSettingsDiscount = '';
          }
        }
      };

      this.addFreeProduct = function () {
        var discount = window.autoDiscount.active;
        var shopifyCartAmount = Spurit.vipCheckoutTotal;
        switch (discount.nameScript) {
          case 'second':
            if (shopifyCartAmount > autoDiscount.second.amount * 100) {
              return this.addDiscountFreeProduct(discount.product, discount.nameScript, discount.freeProduct);
            } else {
              if (discount.product !== undefined) {
                return this.deleteDiscountFreeProduct(discount.product);
              }
            }
            return true;
          case 'third':
            if (shopifyCartAmount > autoDiscount.third.amount * 100 && autoDiscount.third.quantity1 <= discount.collections[autoDiscount.third.collection1]) {
              return this.addDiscountFreeProduct(discount.product, discount.nameScript, discount.freeProduct);
            } else {
              if (discount.product !== undefined) {
                return this.deleteDiscountFreeProduct(discount.product);
              }
            }
            return true;
        }
      };

      this.addCreditsAttr = function () {
        var initialCredits = self.getVipStoreCredits(),
          usedCredits = 0;
        var leftCredits = initialCredits * 100;
        var creditsToUse = typeof Spurit.vipCreditsToUse !== 'undefined' ? Spurit.vipCreditsToUse : leftCredits;
        usedCredits = self.getUsedCredits(self.shopifyCart.items, creditsToUse);
        if (creditsToUse !== false) {
          var attributes = {
            'Used VIP Credits': (usedCredits / 100).toFixed(2),
            'Initial User VIP Balance': initialCredits,
          };
          return self.updateCartNote(attributes);
        } else {
          return true;
        }
      };

      this.deleteDiscountFreeProduct = function (product) {
        var dfd = $.Deferred();
        $.ajax({
          type: 'POST',
          data: {
            quantity: 0,
            id: product.key
          },
          url: '/cart/change.js',
          success: function (data) {
            dfd.resolve(data);
          },
          dataType: 'json'
        });
        return dfd;
      };

      this.addDiscountFreeProduct = function (product, nameScript, freeProduct) {
        var dfd = $.Deferred();
        var property = {};
        property[nameScript] = 'true';
        if (product !== undefined) {
          return true;
        } else {
          var url = '/products/' + freeProduct;
          $.getJSON(url + '.json', function (data) {
            property['auto-free-product'] = data.product.id;
            $.ajax({
              type: 'POST',
              data: {
                quantity: 1,
                id: data.product.variants[0].id,
                properties: property
              },
              url: '/cart/add.js',
              success: function () {
                console.log('add discount product');
                dfd.resolve(true);
              },
              error: function () {
                console.log('fail add discount product');
                dfd.resolve(true);
              },
              dataType: 'json'
            });
          });
          return dfd;
        }
      };

      this.AjaxAddProps = function (item, index, bundle_name = null, vip_lines = null) {
        var properties = {};
        if (bundle_name == null) {
          properties = { 'vip-prop': bundle_name };
          properties = this.mergeProperties(item.properties, properties);
        } else {
          properties = {
            'vip-prop': bundle_name,
            'vip-lines': vip_lines,
          };
          properties.first_vip_vid = self.firstVipVid;
          properties.customer_id = self.customer.id;
          properties.first_vip_type = self.customer.tagSettings.first_discount_type;
          properties.first_vip_discount = self.customer.tagSettings.first_discount;
          properties.first_is_free_shipping = SWPMMParams.itemsCount >= parseInt(self.customer.tagSettings.first_product_quantity);
          properties = this.mergeProperties(item.properties, properties);
        }
        $.ajaxSetup({ async: false, dataType: 'json' });
        result = jQuery.post('/cart/change.js', {
          line: index + 1,
          quantity: item.quantity,
          properties: properties
        }).fail(function (xhr, textStatus, errorThrown) {
          console.log(xhr.responseText);
        });
        return result;
      };

      this.parseDiscounts = function (res, isInit) {
        var $discounts = $(res).find('.total-line--reduction .order-summary__emphasis');   //order discounts
        var productDiscounts = $(res).find('.product-table .reduction-code .reduction-code__text');  // product discounts
        var discount_code_text = $(res).find('.tags-list .reduction-code .reduction-code__text').first().text();
        var dicount_errore = $(res).find('#error-for-reduction_code').text();
        var code = $('#discountCodeInput').val();
        var discount_warning_message = 'We\'re sorry, "' + code + '" coupon cannot be applied to your order. You might be seeing this error because you attempted to combine promotional offers, the voucher was entered incorrectly or it has expired. Any gift card should be entered to the next checkout page. Please contact customer service with any questions.';
        var discount_notice_warning = $(res).find('.notice--warning p').text();
        if (dicount_errore !== '') {
          $('.warning').text(discount_warning_message);
          $('#discount').remove();
        }
        if (discount_notice_warning) {
          $('.warning').text(discount_warning_message);
          $('#discount').remove();
          self.discount_code = {};
        }
        if (discount_code_text !== '') {
          self.discount_code.amount = this.discountValue(productDiscounts, discount_code_text, false);
          self.discount_code.code = discount_code_text;
        }
        $.each($discounts, function () {
          if (!isInit && typeof self.gift_card.amount === 'undefined' && typeof $(this).data('checkout-applied-gift-card-amount-target') !== 'undefined') {
            var gift_point;
            if (typeof self.shopifyCart.attributes.last_characters !== 'undefined') {
              gift_point = self.shopifyCart.attributes.last_characters.toUpperCase();
            }
            if ($(this).parents('tr').text().indexOf(gift_point) === -1) {
              self.gift_card.code = $('input[name=\'discount\']').val();
              self.gift_card.amount = $(this).data('checkout-applied-gift-card-amount-target');
            }
          }
          if (typeof $(this).data('checkout-discount-amount-target') !== 'undefined') {
            self.discount_code.amount = $(this).data('checkout-discount-amount-target');
            self.discount_to_subtotal = self.discount_code.amount;
            self.discount_code.code = discount_code_text;
          }
        });

        //update price from checkout START
        var cartItems = self.getCheckoutItem(res);
        self.auto_discound_amount = 0;

        for (var key in cartItems) {
          if (!isNaN(cartItems[key].discountValue)) {
            self.auto_discound_amount += cartItems[key].discountValue;
          }
        }
        if (!Spurit.isDiscountApply) {
          for (var key in self.discountedVariants) {
            if (self.discountedVariants.hasOwnProperty(key) && key <= 9999999999999999) {
              // var disc = self.discountFromCheckout(cartItems, self.discountedVariants[key].id, self.discountedVariants[key].vid);
              if(cartItems[key] === undefined) {
                delete self.discountedVariants[key];
                continue;
              }
              var disc = cartItems[key].discount;
              if (disc > 0) {
                self.discountedVariants[key].checkout_newPrice = cartItems[key].newPrice;
                self.discountedVariants[key].checkout_quantity = cartItems[key].quantity;
                self.discountedVariants[key].checkout_firstNewPrice = cartItems[key].firstNewPrice;
                self.discountedVariants[key].checkout_firstQuantity = cartItems[key].firstQuantity;
              }
            }
          }
        }

        var checkoutTotal = window.SWPMMParams.cartSubtotal;
        var newCheckoutTotal = this.getCheckoutSubtotal(res);

        if (typeof newCheckoutTotal !== 'undefined') {
          Spurit.newCheckoutTotal = newCheckoutTotal;
          Spurit.vipCheckoutTotal = window.SWPMMParams.cartSubtotal - self.getTotalDiscount() - self.auto_discound_amount;
          self.updateCommonCart(cartItems, checkoutTotal, newCheckoutTotal);
          self.updateSaveMoney(newCheckoutTotal);
        }
        self.showDiscountCodes();
        Spurit.applyVipPrices();
        self.renderBundleDiscountPrice(true);
      };

      this.updateSaveMoney = function (newCheckoutTotal) {
        var saveMoney = SWPMMParams.cartSubtotal - newCheckoutTotal;
        if (typeof self.discount_to_subtotal !== 'undefined' && !isNaN(self.discount_to_subtotal)) {
          saveMoney += self.discount_to_subtotal;
        }
        if (saveMoney) {
          var tmpMoney = '-' + Shopify.formatMoney(saveMoney);
          $('#zeroVipDiscount .value').text(tmpMoney);
        }
      };

      this.getCheckoutSubtotal = function (html) {
        return $(html).find('table .total-line--subtotal .order-summary__emphasis').length ?
          $(html).find('table .total-line--subtotal .order-summary__emphasis').data('checkoutSubtotalPriceTarget') :
          $(html).find('table .total-line .payment-due__price').data('checkoutPaymentDueTarget');
      };

      this.updateCommonCart = function (cartItems, checkoutTotal, newCheckoutTotal) {
        var cartSelector = 'form[action="/cart"] #cartContainer';
        var productSelector = '.CartItem';
        var subtotalSelector = 'form[action="/cart"] .CartSummary';
        //todo why need update base product prices?
        //this.updateProducts($(cartSelector).find(productSelector), cartItems);
        this.updateSubtotal(subtotalSelector, checkoutTotal, newCheckoutTotal);
      };

      this.updateSubtotal = function (subtotal, checkoutTotalText, newCheckoutTotal) {
        $(subtotal).find('#subtotal .value').text(Shopify.formatMoney(checkoutTotalText));
        $(subtotal).find('#grandtotal [class="value"]').text(Shopify.formatMoney(newCheckoutTotal));
        $(subtotal + ' #subtotal .value').attr('data-newCheckoutTotal', Shopify.formatMoney(newCheckoutTotal));
      };

      this.updateProducts = function (products, cartItems) {
        var variant, isAutoDiscount = false;
        $(products).each(function (index, element) {
          variant = $(element).find('.CartItem__Info a').attr('href').split('variant=')[1];
          if (!cartItems[variant]) {
            return;
          }
          if (cartItems[variant].firstNewPrice !== -1 && !isAutoDiscount) {
            $(element).find('.Price:last-of-type').text(Shopify.formatMoney(cartItems[variant].oldPrice));
            isAutoDiscount = true;
          } else {
            $(element).find('.Price:last-of-type').text(Shopify.formatMoney(cartItems[variant].oldPrice));
          }
        });
      };

      this.mergeProperties = function (props, mergeProps) {
        var result = {};
        if (Array.isArray(props)) {
          props.forEach(function (element) {
            result[element.name] = element.value;
          });
        } else {
          result = props;
        }
        mergeProps = Object.assign(result, mergeProps);
        return mergeProps;
      };

      //update price from checkout END
      this.setDiscountedVariants = function (cartItems) {
        // var cartItems = SWPMMParams.items;

        cartItems.forEach(function (item, index, items) {
          var product = {
            id: item.product.id,
            handle: item.product.handle,
            vid: item.id
          };
          if (!self.isContainGiftCardProduct) {
            self.isContainGiftCardProduct = item.gift_card;
          }
          var collections = item.product_collections;
          var isProductTagged = self.isProductTagged(product, collections);
          if (isProductTagged) {
            product.initialPrice = item.product.variant.price;
            product.quantity = item.quantity;
            if(!self.customer.hasVipOrder && item.is_lowest_price_first_vip && parseInt(self.customer.tagSettings.first_discount)) {
              product.newPrice = self.calcNewFirstPrice(item.product.variant.price);
              product.priceBeforeFirstVip = self.calcNewPrice(item.product.variant.price);
              product.firstDiscount = item.product.variant.price - product.priceBeforeFirstVip;
              self.firstVipVid = product.vid;
            } else {
              product.newPrice = self.calcNewPrice(item.product.variant.price);
            }
            product.discount = item.product.variant.price - product.newPrice;
            if (typeof self.discountedVariants[item.id] === 'undefined') {
              self.discounted_lines += product.vid + ', ';
              self.discountedVariants[item.id] = product;
            } else {
              self.discountedVariants[item.id].quantity += product.quantity;
            }
          }
        });
      };

      this.getDiscountedItem = function (cartItemId) {
        return self.discountedVariants[cartItemId] || false;
      };

      this.getTotalDiscount = function () {
        var total = 0;
        var discoutedItems = this.discountedVariants;
        var excludeVariants = self.excludeBundleVariants(discoutedItems);

        for (var cartItemId in discoutedItems) {
          if(excludeVariants.indexOf(cartItemId) === -1) {
            var autoDiscount = (typeof discoutedItems[cartItemId].checkout_quantity !== 'undefined') ? discoutedItems[cartItemId].checkout_quantity : 0;
            if (discoutedItems.hasOwnProperty(cartItemId)) {
              if (discoutedItems[cartItemId].priceBeforeFirstVip) {
                total += discoutedItems[cartItemId].discount;
                total += discoutedItems[cartItemId].firstDiscount * (discoutedItems[cartItemId].quantity - 1 - autoDiscount);
              } else {
                total += discoutedItems[cartItemId].discount * (discoutedItems[cartItemId].quantity - autoDiscount);
              }
            }
          }
        }

        return total;
      };

      this.initPriceUpdater = function () {
        // callback to modify price elements or price values
        // Spurit.funcPriceOnDisplay = function(oldPriceElement, newPriceElement, oldAmount, newAmount){
        // Decorating and processing html-elements with
        // old and new prices after new price displayed
        // if ( !self.customer.tagSettings.enable_show_compare_at_price ) {
        //     // console.log(oldPriceElement);
        //     $(oldPriceElement).hide();
        // }
        // }

        // callback called by Spurit.prices.recalculate trigger
        // Spurit.prices.onChange(
        //     'subtotal', //price key = 1st param of the Spurit.prices.recalculate
        //     function (price, next) {
        //         if(!Spurit.isDraftOrder) {
        //             return false;
        //         }
        //         price -= self.getTotalDiscount();
        //         next(price);
        //     },
        //     document.querySelectorAll(Config.get('cart_subtotal')) //pass subtotal element
        // );
        Spurit.prices.onChange(
          'total', //price key = 1st param of the Spurit.prices.recalculate
          function (price, next) {
            if (!Spurit.isDraftOrder) {
              return false;
            }

            price -= self.getTotalDiscount();
            var priceAfterVipDiscount = price;

            var vipCreditsDiscount = typeof Spurit.vipCreditsToUse !== 'undefined' ? Spurit.vipCreditsToUse : 0;
            if (vipCreditsDiscount) {
              price -= vipCreditsDiscount;
            }

            if (typeof self.gift_card !== 'undefined' && typeof self.gift_card.amount !== 'undefined') {
              price -= self.gift_card.amount;
            }
            if (typeof self.discount_code !== 'undefined' && typeof self.discount_code.amount !== 'undefined'  && priceAfterVipDiscount >= SWPMMParams.discountCodeThreshold && self.isDiscountAvailable(self.discount_code.code)) {
                price -= self.discount_code.amount;
            }
            if (typeof self.auto_discound_amount !== 'undefined' && !isNaN(self.auto_discound_amount)) {
              price -= self.auto_discound_amount;
            }
            $('#grandtotal .value:not(.sp-price)').attr('style', '');
            next(price);
          },
          document.querySelectorAll(Config.get('cart_total')) //pass subtotal element
        );
      };

      this.updateCartNote = function (attributes) {
        return jQuery.post('/cart/update.js', {
          attributes: attributes,
        }, null, 'json');
      };

      function loadingStart () {
        $('button[name="checkout"]').prop('disabled', true);
        $('body').addClass('no-scroll');
        $('#vipOrderLoading').addClass('is-active');
      }

      function loadingEnd () {
        $('body').removeClass('no-scroll');
        $('#vipOrderLoading').removeClass('is-active');
        $('button[name="checkout"]').prop('disabled', false);
      }

      this.initCheckout = function (vipCheckout = true) {
        Spurit.checkout.setOptions({ hash: Config.getHash() });
        //for vip checkout only
        $(Config.get('cartForm')).submit(function (e) {
          e.preventDefault();
          loadingStart();
          var request = {};
          var addProps;
          var apiUrl = Config.get('apiUrl');
          var initialCredits = self.getVipStoreCredits(),
            usedCredits = 0;
          var leftCredits = initialCredits * 100;
          var creditsToUse = typeof Spurit.vipCreditsToUse !== 'undefined' ? Spurit.vipCreditsToUse : leftCredits;
          usedCredits = self.getUsedCredits(self.shopifyCart.items, creditsToUse);
          if (SWPMMParams.items.length && vipCheckout) {
            addProps = self.AjaxAddProps(SWPMMParams.items[0], 0, 'vip-price', self.discounted_lines);
          } else {
            addProps = true;
            usedCredits = self.shopifyCart.items_subtotal_price > creditsToUse ? creditsToUse : self.shopifyCart.items_subtotal_price;
          }
          if (creditsToUse !== false) {
            var attributes = {
              'Used VIP Credits': self.isContainGiftCardProduct ? 0 : (usedCredits / 100).toFixed(2),
              'Initial User VIP Balance': initialCredits,
            };
            request.cartAttributes = attributes;
            var updateCartNote = self.updateCartNote(attributes);
          }

          if (typeof self.customer !== 'undefined' && typeof self.customer.id !== 'undefined') {
            request.customer = { id: self.customer.id };
          }
          if (typeof request.customer !== 'undefined' && typeof request.cartAttributes !== 'undefined') {
            $.ajax({
              url: apiUrl + '/checkout/viporder',
              dataType: 'json',
              type: 'post',
              headers: {
                'X-Store-Hash': Config.getHash()
              },
              contentType: 'application/json',
              data: JSON.stringify(request),
              processData: false,
              success: function (data, textStatus, jQxhr) {
                if (typeof addProps !== 'undefined') {
                  $.when(updateCartNote, addProps).done(function (arg1, arg2) {
                    if (typeof data.code !== 'undefined') {
                      $.when(
                        jQuery.post('/cart/update.js', {
                          attributes: {
                            'code id': data.id,
                            'last_characters': data.last_characters,
                            'code': data.code
                          },
                          note: '{"last_characters":"' + data.last_characters + '", ' + '"old_last_characters":"' + data.old_last_characters + '", ' + '"is_gift_product":"' + self.isContainGiftCardProduct + '"}'
                        }, null, 'json')
                      ).then(function () {
                        window.location.href = Config.get('checkoutUrl') + '?discount=' + data.code;
                      });
                    } else {
                      $.when(
                        jQuery.post('/cart/update.js', {
                          attributes: { 'code': '' },
                          note: '{"last_characters":"' + data.last_characters + '", ' + '"old_last_characters":"' + data.old_last_characters + '", ' + '"is_gift_product":"' + self.isContainGiftCardProduct + '"}'
                        }, null, 'json')
                      ).done(function (a1) {
                        window.location.href = Config.get('checkoutUrl');
                      });
                    }
                  });
                } else {
                  window.location.href = Config.get('checkoutUrl');
                }
              },
              error: function (jqXhr, textStatus, errorThrown) {
                loadingEnd();
                var alertMessage = 'An error occurred. Please try again later';
                if (typeof jqXhr.responseJSON !== 'undefined' && typeof jqXhr.responseJSON.error !== 'undefined') {
                  alertMessage = jqXhr.responseJSON.error;
                } else {
                  if (typeof jqXhr.statusText !== 'undefined') {
                    alertMessage = jqXhr.statusText;
                  }
                }
                Spurit.showAlert(alertMessage);
                console.log(errorThrown);
              }
            });
          } else {
            if (typeof addProps !== 'undefined') {
              $.when(addProps).then(function () {
                window.location.href = Config.get('checkoutUrl');
              });
            } else {
              window.location.href = Config.get('checkoutUrl');
            }
          }
        });
      };

      this.getUsedCredits = function (lineItems, creditsToUse) {
        var usedCredits = 0;
        lineItems.every(function (lineItem) {
          var fullDiscount = 0;
          var discountedItem = self.getDiscountedItem(lineItem.id);
          if (discountedItem && discountedItem.newPrice < discountedItem.initialPrice) {
            lineItem.discounted_price = discountedItem.newPrice;
          }

          if (creditsToUse === false || !parseFloat(creditsToUse) || lineItem.discounted_price === 0) {
            return true;
          }

          if (discountedItem.firstDiscount) {
            fullDiscount = discountedItem.newPrice + discountedItem.priceBeforeFirstVip * (lineItem.quantity - 1);
          } else {
            fullDiscount = lineItem.discounted_price * lineItem.quantity;
          }

          if (fullDiscount < creditsToUse) {
            creditsToUse -= fullDiscount;
            usedCredits += fullDiscount;
            lineItem.discounted_price = 0;
            return true;
          }

          // last item to apply VIP credits
          lineItem.discounted_price -= creditsToUse / lineItem.quantity;
          usedCredits += creditsToUse;
          creditsToUse = 0;

          return true;
        });
        return usedCredits;
      };

      this.displayItemPrices = function () {
        var $$priceElements = $(Config.get('cart_product_price'));
        var $$priceTotalElements = $(Config.get('cart_first_product_subtotal')).filter(function (index) {
          return $(this).closest(Config.get('cart_product_wrapper')).css('display') !== 'none';
        });

        // if ( $$priceElements.length && $$priceTotalElements.length != $$priceElements.length) {
        //     throw new Error('Wholesale App Configuration is invalid!');
        // }

        var cartItems = SWPMMParams.items.filter(function (item) {
          return item.product.tags.indexOf('vip-hidden-product') === -1;
        });
        if (($$priceElements.length / cartItems.length) % 2) {
          // sometimes cart rows house more than one price
          return false;
        }
        /**
         * Amount of repeated prices
         * @var int
         */
        var k = ($$priceElements.length || $$priceTotalElements.length) / cartItems.length;
        var autoDiscountItems = [];
        $$priceElements.each(function (index, element) {
          var cartItem = cartItems[parseInt(index / k)];
          var discountedItem = self.getDiscountedItem(cartItem.id) || null;
          if (discountedItem && discountedItem.newPrice < discountedItem.initialPrice) {
            var newPrice = discountedItem.newPrice;
            self.displayNewItemPrice(element, newPrice);
          }
        });
        $$priceTotalElements.each(function (index, element) {
          var cartItem = cartItems[parseInt(index / k)];
          if (typeof cartItem === 'undefined') {
            return false;
          }
          var discountedItem = self.getDiscountedItem(cartItem.id) || null;
          if (discountedItem && ((discountedItem.newPrice < discountedItem.initialPrice) || (self.isBundleDiscount(cartItem.product) && discountedItem.checkout_newPrice < discountedItem.initialPrice))) {
            var newPrice = discountedItem.newPrice * cartItem.quantity;
            if(discountedItem.priceBeforeFirstVip !== undefined) {
              newPrice = discountedItem.newPrice + discountedItem.priceBeforeFirstVip * (cartItem.quantity - 1);
            }
            if (typeof discountedItem.checkout_newPrice !== 'undefined' && Config.get('excludeScripts').indexOf(window.SWPMMParams.scriptId) === -1) {     //fix new auto-discount split
              if (discountedItem.checkout_firstNewPrice === -1) {
                newPrice = discountedItem.checkout_newPrice;
              } else {
                if (autoDiscountItems.indexOf(discountedItem.vid) !== -1) {
                  newPrice = discountedItem.checkout_newPrice;
                } else {
                  if(discountedItem.priceBeforeFirstVip !== undefined) {
                    newPrice = discountedItem.newPrice + discountedItem.priceBeforeFirstVip * (cartItem.quantity - 1);
                  } else {
                    newPrice = discountedItem.newPrice * discountedItem.checkout_firstQuantity;
                  }
                }
                if (k === 2) {
                  if (index % k !== 0) {
                    autoDiscountItems.push(discountedItem.vid);
                  }
                } else {
                  autoDiscountItems.push(discountedItem.vid);
                }
              }
            }
            if(discountedItem.priceBeforeFirstVip !== undefined) {
              self.displayNewItemPrice(element, discountedItem.priceBeforeFirstVip * cartItem.quantity);
              self.displayFirstVipPrice(element.parentElement.firstElementChild, newPrice);
            } else {
              self.displayNewItemPrice(element, newPrice);
            }
          }
          //hot fix for excludeScripts(don't show discount for line-item on VIP tab) and items without VIP prices.
          if(Config.get('excludeScripts').indexOf(window.SWPMMParams.scriptId) !== -1 && discountedItem === null) {
            self.removeLineItemDiscountOnVipTab(element, cartItem.product.variant.price*cartItem.quantity);
          }
        });
      };

      this.displayFirstVipPrice = function (pricehtmlEl, newPrice) {
        var $priceEl = $(pricehtmlEl);
        var $discountedPriceEl = $priceEl.clone();
        var $checkCompareAt = $(pricehtmlEl.parentNode);
        $priceEl.before($discountedPriceEl);
        $priceEl.addClass('remove-with-reset Price--compareAt Text--subdued');
        $priceEl.removeClass('sp-price');
        $priceEl.removeClass('Price--highlight');
        $discountedPriceEl.html(Spurit.prices.formatMoney(newPrice) + ' <span class="vip-label">'+Config.get('firstVipPricePostfix')+'</span>');
        if ($checkCompareAt.children('.CartItem__Price.Price--compareAt.remove-with-reset').length > 1) {
          $checkCompareAt.children('.CartItem__Price.Price--compareAt.remove-with-reset')[1].remove();
        }
      }

      this.displayNewItemPrice = function (pricehtmlEl, newPrice) {
        // check sibling with class
        var $priceEl = $(pricehtmlEl);
        var $discountedPriceEl = $(pricehtmlEl.previousSibling);
        var $checkCompareAt = $(pricehtmlEl.parentNode);
        var additionalPrice = '';

        if ($discountedPriceEl.hasClass('sp-price')) {
          // if yes
          // update discounted price
        } else {
          // if not
          // clone, add class, insert discounted price
          $discountedPriceEl = $priceEl.clone();
          $discountedPriceEl.addClass('sp-price');
          $priceEl.before($discountedPriceEl);

          self.setStyle(pricehtmlEl, 'display', 'none');
          // $priceEl.css('text-decoration', 'line-throught !important')
          if (!$checkCompareAt.children('.Price--compareAt').length) {
            additionalPrice = '<span class="Text--subdued Price--compareAt remove-with-reset">' + $priceEl.html() + '</span>';
          }
        }
        $discountedPriceEl.html(Spurit.prices.formatMoney(newPrice) + ' <span class="vip-label">VIP</span>');
        if (additionalPrice) {
          $discountedPriceEl.after(additionalPrice);
        }
      };

      this.removeLineItemDiscountOnVipTab = function (pricehtmlEl, newPrice) {
        var $priceEl = $(pricehtmlEl);
        var $discountedPriceEl = $(pricehtmlEl.previousSibling);
        var $checkCompareAt = $(pricehtmlEl.parentNode);

        $discountedPriceEl = $priceEl.clone();
        $discountedPriceEl.addClass('remove-with-reset').removeClass('Price--highlight');
        $priceEl.before($discountedPriceEl);
        self.setStyle(pricehtmlEl, 'display', 'none');
        if ($checkCompareAt.children('.Price--compareAt').length) {
          $checkCompareAt.children('.Price--compareAt').each(function (index, element) {
            self.setStyle(element, 'display', 'none');
          });

          $discountedPriceEl.html(Spurit.prices.formatMoney(newPrice));
        }
      }

      this.createVipWidget = function () {
        var $checkoutBtn = $('button[name=\'checkout\']');
        var paygTitle = $('#cartDisclaimer').data('paygTitle');
        $('#main').append('<div id="vipOrderLoading" class=""></div>');
        if (this.isVipCustomer() || this.isWholesaleCustomer()) {
          this.initCheckout();
          this.showCartAlreadyVipWidget();
          return false;
        }
        if (SWPMMParams.items.length > 0) {
          $('#vipOrderLoading').addClass('is-active');
        }
        if (!this.isVipCustomer() && self.getVipStoreCredits()) {
          this.initCheckout(false);
        }
        $('#cartVipWidget').removeClass('is-hidden');

        var $btnClone = $checkoutBtn.clone().attr('id', 'vipCheckout');
        if (paygTitle) {
          $checkoutBtn.text(paygTitle);
        }
        $checkoutBtn.after($btnClone);

        $checkoutBtn.toggle();

        $('body')
          .on('change', '#cartVipWidget input', function () {
            $('.vip-widget__description ul').addClass('is-hidden');
            self.renderBundleDiscountPrice(false);
            var typeTab = parseInt(this.value);
            self.redrawCommonDiscountPrices(typeTab);
            if (typeTab) {
              Spurit.applyVipPrices();
              $('#vipDesc').removeClass('is-hidden');
              $('#cartDisclaimer').removeClass('is-hidden');
              $('#zeroVipDiscount').addClass('is-hidden');
              $('#freeShippingText .value').html('FREE');
              $('#vipDiscount').removeClass('is-hidden');
              if (Spurit.vipCheckoutTotal >= SWPMMParams.discountCodeThreshold) {
                $('#discount').removeClass('is-hidden');
              }
            } else {
              Spurit.resetVipPrices();
              $('#regDesc').removeClass('is-hidden');
              $('#cartDisclaimer').addClass('is-hidden');
              $('#discount').addClass('is-hidden');
              $('#freeShippingText .value').html('(to be calculated)');
            }
            var valueProps = typeTab ? 'vip-price' : '';
            self.reNewBundleDiscountProps(valueProps);
            $('button[name=\'checkout\']').toggle();
            $('.warning').text('');
            if (self.getVipStoreCredits() && $('#vipStoreCreditsInput').length && !self.isContainGiftCardProduct) {
              self.showVipCreditsInput();
            }
          })
          .on('click', '#vipCheckout', function (e) {
            // e.preventDefault();
            // self.checkVipShippingIs(true, self.goToVipCheckout);
          });
      };

      this.goToVipCheckout = function () {
        window.location.href = '/pages/checkout';
      };

      this.showDiscountCodes = function (callback) {
        if(typeof callback === 'undefined') {
          callback = function(){}
        }

        var $subtotal = $('#subtotal');
        var divClass = '';
        if (typeof self.gift_card !== 'undefined' && typeof self.gift_card.amount !== 'undefined' && !$('#gift').length) {
          $subtotal.after('<p id=\'gift\'><span class=\'title\'>Gift Card</span><span class=\'value\'>- ' + Shopify.formatMoney(self.gift_card.amount) + '</span></p>');
        }
        if (typeof self.discount_code !== 'undefined' && typeof self.discount_code.amount !== 'undefined') {
          if ($('#discount').length) {
            $('#discount').remove();
          }
          var code = '';
          if (typeof self.discount_code.code !== 'undefined') {
            code = ' ' + self.discount_code.code;
          }
          if (Spurit.isDiscountApply) {
            divClass = '';
            if (self.getVipStoreCredits() && !self.isContainGiftCardProduct) {
              self.showVipCreditsInput();
            }
          }
          if (Spurit.vipCheckoutTotal < SWPMMParams.discountCodeThreshold) {
            divClass += ' is-hidden';
          }
          var isVipSelect = parseInt($('#cartVipWidget input:checked').val());
          if (self.discount_code.amount && isVipSelect && self.isDiscountAvailable(self.discount_code.code)) {
            $subtotal.after('<p id=\'discount\' class=\'' + divClass + '\'><span class=\'title\'>Discount Code' + code + '</span><span class=\'value\'>- ' + Shopify.formatMoney(self.discount_code.amount) + '</span></p>');
          }
        }

        Spurit.prices.recalculate('total', Config.get('cartSubtotal'), function () {
          var amount = self.getTotalDiscount()
          if(self.isBundleDiscount()) {
            var newSubtotal = callback();
            if (newSubtotal) {
              amount += SWPMMParams.cartSubtotal - newSubtotal;
            }
          }
          self.showVipDiscount(amount);

          if (self.getVipStoreCredits() && !self.isContainGiftCardProduct) {
            self.showVipCreditsInput();
          }
          $('#vipOrderLoading').removeClass('is-active');
        });
      };

      this.showVipDiscount = function (amount) {
        var $salesTax = $('#freeShippingText');
        if (typeof amount !== 'undefined' && !$('#vipDiscount').length) {
          var prefix = (amount) ? '-' : '';
          $salesTax.before('<p id=\'vipDiscount\' class="Text--secondary"><span class=\'title\'>VIP Discount</span><span class=\'value\'>'+ prefix + Shopify.formatMoney(amount) + '</span></p>');
        }
      };

      this.showVipCreditsInput = function () {
        this.orderTotal = 0;
        var vipStoreCredits = self.getVipStoreCredits() * 100;
        var vipDiscountValue = $('#vipDiscount .value').html();
        if (typeof Spurit.vipCreditsToUse !== 'undefined') {
          Spurit.vipCreditsToUse = vipStoreCredits;
        } else {
          Spurit.vipCreditsToUse = vipStoreCredits;
        }
        if (vipDiscountValue) {
          var vipDiscount = self.deleteMoneyFormat(vipDiscountValue);
          var orderTotal = window.SWPMMParams.cartSubtotal - vipDiscount;
        }
        if (self.auto_discound_amount > 0) {
          orderTotal = orderTotal - self.auto_discound_amount;
        }

        if (!self.isVipCustomer() && !Spurit.isDraftOrder) {
          var newSubTotal = self.deleteMoneyFormat($('#subtotal .value').attr('data-newcheckouttotal').trim());
          orderTotal = newSubTotal;
        }
        if (self.discount_to_subtotal) {
          if(Spurit.isDraftOrder) {
            orderTotal -= orderTotal >= SWPMMParams.discountCodeThreshold?self.discount_to_subtotal:0;
          } else {
            orderTotal -= self.discount_to_subtotal;
          }
        }
        if (!jQuery.isEmptyObject(self.gift_card)) {
          orderTotal -= self.gift_card.amount;
        }
        this.orderTotal = orderTotal;
        var creditsToUse = vipStoreCredits;
        if (orderTotal < vipStoreCredits) {
          creditsToUse = orderTotal;
        }
        Spurit.vipCreditsToUse = creditsToUse;
        var formatCreditalsToUse = Shopify.formatMoney(creditsToUse, '{{amount}}');
        var formatMaxCreditals = Shopify.formatMoney(vipStoreCredits, '{{amount}}');

        if (!$('#vipStoreCreditsInput').length) {

          var creditsInputSelector = Config.get('creditsInputSelector');
          var creditsMaxSelector = Config.get('creditsMaxSelector');

          var inputSize = (creditsToUse.toFixed() + '').length + 2;
          var inputSize2 = (vipStoreCredits.toFixed() + '').length + 3;

          $('.Cart__GrandTotal').before('<div class=\'Cart__Recap\' id=\'vipStoreCreditsInput\'>' +
            '<div class=\'title\'>Apply Store Credits</div>' +
            '<div class="creditsInputContainer">' +
            '<input type="text" name="creditsValue" value="' + formatCreditalsToUse + '" size="' + inputSize + '">' +
            '<input type="text" name="creditsMax" value="/  ' + formatMaxCreditals + '" size="' + inputSize2 + '">' +
            '<div class="btn-box">' +
            '<div class="credits-btn credits-btn-up"></div>' +
            '<div class="credits-btn credits-btn-down"></div>' +
            '</div>' +
            '</div>' +
            '<div class="value creditsValueText">-' + Shopify.formatMoney(creditsToUse) + '</div>' +
            '</div>'
          );

          var inputMinWidth = $(creditsInputSelector).width() + $(creditsMaxSelector).width() + $('.btn-box').width() + 21;
          $('.creditsInputContainer').css('min-width', inputMinWidth + 1);

          $(creditsInputSelector).on('change', function () {
            // if not equal with saved value

            var inputVal = self.deleteMoneyFormat($(this).val());
            if (inputVal > self.orderTotal) {
              inputVal = self.orderTotal;
            }
            if (inputVal > self.getVipStoreCredits() * 100) {
              inputVal = self.getVipStoreCredits() * 100;
            }

            Spurit.vipCreditsToUse = inputVal;

            $(this).val(Shopify.formatMoney(inputVal, '{{amount}}'));
            $('.creditsValueText').text('-' + Shopify.formatMoney(inputVal));

            self.updateGrandTotal();

            Spurit.prices.recalculate('total', Config.get('cartSubtotal'), function () {
            });
          });

          $('.credits-btn').on('click', function () {
            imitateClick(this);
            var creditValue = self.deleteMoneyFormat($(creditsInputSelector).val());

            if ($(this).hasClass('credits-btn-up')) {
              creditValue += 100;
            } else if ($(this).hasClass('credits-btn-down')) {
              creditValue -= 100;
              if (creditValue < 0) creditValue = 0;
            }
            $(creditsInputSelector).val(Shopify.formatMoney(creditValue, '{{amount}}'));
            $(creditsInputSelector).change();
          });

          function imitateClick (el) {
            var elem = $(el);
            elem.css('border-color', '#EB637D');
            elem.css('color', '#EB637D');
            setTimeout(function () {
              elem.removeAttr('style');
            }, 100);
          }
        } else {
          $('#vipStoreCreditsInput input[name=creditsValue]').attr('value', formatCreditalsToUse);
          $('#vipStoreCreditsInput input[name=creditsValue]').val(formatCreditalsToUse);
          $('#vipStoreCreditsInput input[name=creditsMax]').attr('value', '/  ' + formatMaxCreditals);
          $('.creditsValueText').text('-' + Shopify.formatMoney(creditsToUse));
          if (!Spurit.isDraftOrder) {
            Spurit.vipCreditsToUse = creditsToUse;
            self.updateGrandTotal();
          }
        }
      };

      this.updateGrandTotal = function () {
        var grandtotal = self.deleteMoneyFormat($('#subtotal .value').attr('data-newcheckouttotal').trim());
        if (typeof self.discount_to_subtotal !== 'undefined' && !isNaN(self.discount_to_subtotal)) {
          grandtotal -= self.discount_to_subtotal;
        }
        if (typeof Spurit.vipCreditsToUse !== 'undefined') {
          var inputVal = self.deleteMoneyFormat($(Config.get('creditsInputSelector')).val());
          grandtotal -= inputVal;
        }
        $('#grandtotal .value').text(Shopify.formatMoney(grandtotal));
      };

      this.showCartAlreadyVipWidget = function () {
        $('#cartAlreadyVipWidget').removeClass('is-hidden');
      };

      Spurit.applyVipPrices = this.updatePrices;
      Spurit.resetVipPrices = this.resetPrices;
      Spurit.refreshCart = this.refreshCart;
      Spurit.isDraftOrder = false;
      Spurit.isDiscountApply = false;
    };

    var VipCheckoutPage = function () {
      var self = this;
      App.apply(this, arguments);
      this.init = function () {
        loadScript('https://js.braintreegateway.com/web/dropin/1.11.0/js/dropin.min.js', function () {
          var apiUrl = Config.get('apiUrl');
          var debugString = Config.get('debugString') || '';

          stateSelecting();
          if (self.storeCredits && !self.isContainGiftCardProduct) {
            appendStoreCredits(self.storeCredits);
          }
          if (self.cartDiscount) {
            appendDiscount(self.cartDiscount.amount);
          }
          appendShippingRate();
          appendTaxRate();
          $.ajax({
            // GET method
            url: apiUrl + '/checkout/token' + debugString,
            dataType: 'json',
            headers: { 'X-Store-Hash': Config.getHash() },
            success: function (res) {
              tokenReceived(res, apiUrl + '/checkout/orderandsubscription' + debugString);
            }
          });
        });
        Config.init();
        self.customer = SWPMMParams.customer;

        if ($('#address_country').val() === 'United States') {
          self.checkVipShippingIs(true);
        }
        self.storeCredits = self.getVipStoreCredits() ? getUsedStoreCredits() : 0;
        self.isContainGiftCardProduct = false;
        createCustomOrder();
        populateItems();
      };

      function loadingStart () {
        $('button.button').prop('disabled', true);
        $('body').addClass('no-scroll');
        $('#vipOrderLoading').addClass('is-active');
      }

      function loadingEnd () {
        $('body').removeClass('no-scroll');
        $('#vipOrderLoading').removeClass('is-active');
        $('button.button').prop('disabled', false);
      }

      function tokenReceived (res, callbackUrl) {
        var $form = $('#payment-form');
        if (!res.token)
          throw new Error('Get token error');
        braintree.dropin.create({
          authorization: res.token,
          selector: '#bt-dropin'
        }, function (createErr, instance) {
          if (createErr) {
            console.log('Create Error', createErr);
            return;
          }
          $form.on('submit', function (event) {
            event.preventDefault();
            loadingStart();

            if (typeof window.shippingRates === 'undefined') {
              var errMsg = 'Shipping method is a required field';
              if ($('#shipping-rates-feedback').html()) {
                errMsg = $('#shipping-rates-feedback').html();
              }
              Spurit.showAlert(errMsg);
              loadingEnd();
              return;
            }

            instance.requestPaymentMethod(function (err, payload) {
              if (err) {
                console.log('Request Payment Method Error', err);
                loadingEnd();
                return;
              }

              $.ajax({
                type: 'GET',
                url: '/cart.js',
                async: false,
                dataType: 'json',
                success: function (cart) {
                  if (cart.items.length === 0) {
                    console.log('REDIRECT');
                    window.location.href = '/';
                    return;
                  }
                  var request = Spurit.vipOrder;
                  var totalSum = request.subtotal_price;
                  request.nonce = payload.nonce;
                  request.email = $form.find('#emailAddress').val();
                  request.shipping_lines = [{
                    'title': window.shippingRates[$('input:checked').data('i')].name,
                    'price': parseFloat(window.shippingRates[$('input:checked').data('i')].price.replace(/\$|,/g, ''), 10),
                    'code': window.shippingRates[$('input:checked').data('i')].code,
                    'source': window.shippingRates[$('input:checked').data('i')].source
                  }];
                  request.send_receipt = true;
                  request.subtotal_price = window.vipPriceChanged(false);
                  request.shipping_address = {
                    first_name: $form.find('#firstName').val(),
                    last_name: $form.find('#lastName').val(),
                    phone: $form.find('#phoneNumber').val(),
                    address1: $form.find('#streetAddress').val(),
                    city: $form.find('#cityInput').val(),
                    country: $form.find('#countrySelect select').val(),
                    zip: $form.find('#address_zip').val()
                  };
                  request.billing_address = request.shipping_address;

                  if (!$form.find('#address_province').attr('disabled')) {
                    request.shipping_address.province = $form.find('#address_province').val();
                  }

                  if (self.customer.isVipRemoved) {
                    if (typeof request.note_attributes !== 'undefined') {
                      request.note_attributes.push({
                        name: Config.get('customerVipSubscriptionLabel'),
                        value: Config.get('customerVipSubscriptionCost')
                      });
                    } else {
                      request.note_attributes = {
                        [Config.get('customerVipSubscriptionLabel')]: Config.get('customerVipSubscriptionCost')
                      };
                    }
                  }
                  if (request.total_tax) {
                    totalSum += request.total_tax;
                  }
                  if (request.shipping_lines.length > 0) {
                    totalSum += request.shipping_lines[0].price;
                  }
                  if (request.discount_codes) {
                    totalSum -= (typeof request.discount_codes[0].amount !== 'undefined' && request.discount_codes[0].amount) !== null ? request.discount_codes[0].amount : 0;
                  }
                  $.ajax({
                    url: callbackUrl,
                    dataType: 'json',
                    type: 'post',
                    headers: {
                      'X-Store-Hash': Config.getHash()
                    },
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    processData: false,
                    success: function (data, textStatus, jQxhr) {
                      window.setTimeout(clearCart(function () {
                        window.location.href = data.order_status_url;
                      }), 200);
                      fbq('track', 'Purchase', {
                        value: request.subtotal_price || 0,
                        currency: 'USD',
                        customer: request.customer.id,
                      });
                      fbq('trackCustom', 'Subscribe', {
                        value: request.subtotal_price,
                        currency: 'USD',
                      });
                      fbq('trackCustom', 'VIP', {
                        number: data.number
                      });
                      fbq('trackCustom', 'VIP$', {
                        value: request.subtotal_price,
                        currency: 'USD',
                      });
                      gtag('config', 'UA-52636943-1');
                      gtag('event', 'purchase', {
                        'transaction_id': data.number,
                        'affiliation': 'Madamglam Braintree',
                        'value': totalSum,
                        'currency': 'USD',
                        'tax': request.total_tax || 0,
                        'shipping': request.shipping_lines[0].price || 0
                      });
                    },
                    error: function (jqXhr, textStatus, errorThrown) {
                      loadingEnd();
                      var alertMessage = 'An error occurred. Please try again later';
                      if (typeof jqXhr.responseJSON !== 'undefined' && typeof jqXhr.responseJSON.error !== 'undefined') {
                        alertMessage = jqXhr.responseJSON.error;
                      } else {
                        if (typeof jqXhr.statusText !== 'undefined') {
                          alertMessage = jqXhr.statusText;
                        }
                      }
                      Spurit.showAlert(alertMessage);
                      if(jqXhr.responseJSON.redirect !== 'undefined') {
                        window.location.href = jqXhr.responseJSON.redirect;
                      }
                      console.log(errorThrown);
                    }
                  });
                }
              });
            });
          });
        });
      }

      window.vipPriceIsChanging = false;
      window.vipPriceChanged = function (recalculateTaxes) {

        if (typeof recalculateTaxes === 'undefined') {
          recalculateTaxes = true;
        }

        // Shipping
        var shippinglValue = $('#cartShippingValue').html();
        var taxesValue = $('#cartTaxesValue').html();
        var storeCreditsValue = $('#cartCreditsValue').html();
        if (typeof shippinglValue === 'undefined' || typeof taxesValue === 'undefined') {
          return false;
        }

        var subscriptionValue = $('#cartSubscriptionValue').html() || '0';
        subscriptionValue = parseFloat(subscriptionValue.replace(/\$|,/g, ''), 10);

        var cartDiscountValue = $('#cartDiscountValue').html() || '0';
        cartDiscountValue = parseFloat(cartDiscountValue.replace(/-\$|,/g, ''), 10);

        shippinglValue = parseFloat(shippinglValue.replace(/\$|,/g, ''), 10);
        taxesValue = parseFloat(taxesValue.replace(/\$|,/g, ''), 10);
        storeCreditsValue = (typeof storeCreditsValue !== 'undefined') ? parseFloat(storeCreditsValue.replace(/-\$|,/g, ''), 10) : 0;

        var totalValue = parseFloat($('#cartSubtotalValue').html().replace(/\$|,/g, ''), 10);
        $('#cartTotalValue').html(Shopify.formatMoney((totalValue + shippinglValue + taxesValue + subscriptionValue - cartDiscountValue - storeCreditsValue) * 100));

        // calculate Taxes
        if (recalculateTaxes && !window.vipPriceIsChanging && typeof Spurit !== 'undefined' && typeof Spurit.vipOrder !== 'undefined') {
          var $form = $('#payment-form');
          Spurit.vipOrder.shipping_address = {
            first_name: $form.find('#firstName').val(),
            last_name: $form.find('#lastName').val(),
            phone: $form.find('#phoneNumber').val(),
            address1: $form.find('#streetAddress').val(),
            city: $form.find('#cityInput').val(),
            province: $form.find('#address_province').val(),
            country: $form.find('#countrySelect select').val(),
            zip: $form.find('#address_zip').val()
          };

          window.vipPriceIsChanging = true;
          loadingStart();

          var debugString = Config.get('debugString') || '';
          $.ajax({
            url: Config.get('apiUrl') + '/checkout/calculateTaxes' + debugString,
            method: 'POST',
            data: { orderData: Spurit.vipOrder },
            dataType: 'json',
            headers: { 'X-Store-Hash': Config.getHash() },
            error: function (res) {
              console.log(res.responseText);
            },
            complete: function (res) {
              window.vipPriceIsChanging = false;
              loadingEnd();
              if (!Array.isArray(res)) {
                if (Array.isArray(res.responseJSON)) {
                  res = res.responseJSON;
                } else {
                  $('#cartTaxesValue').html(Shopify.formatMoney(0));
                  return false;
                }
              }
              var totalTaxes = 0;

              for (var tax in res) {
                if (!res.hasOwnProperty(tax)) {
                  continue;
                }
                totalTaxes += res[tax].price;
              }

              Spurit.vipOrder.tax_lines = res;
              Spurit.vipOrder.total_tax = totalTaxes;

              $('#cartTaxesValue').html(Shopify.formatMoney(totalTaxes * 100));
              window.vipPriceChanged(false);
            }
          });
        } else {
          return totalValue;// + shippinglValue + taxesValue;
        }

      };

      function clearCart (callback) {
        $.ajax({
          type: 'POST',
          url: '/cart/clear.js',
          success: function () {
            console.log('cleared the cart');
            callback();
          },
          dataType: 'json'
        });
      }

      function stateSelecting () {
        var defaultState = $('#address_province').html(),
          keysToDelete = [];
        $.each($('#countrySelect option'), function (key, value) {
          if ($('#countrySelect option')[key].value !== 'United States' && $('#countrySelect option')[key].value !== '') {
            keysToDelete.push(key);
          }
          if ($('#countrySelect option')[key].value === '---') {
            return false;
          }
        });
        $.each(keysToDelete.reverse(), function (key, value) {
          $('#countrySelect option')[value].remove();
        });
        if (typeof SWPMMParams.customer.shipping_address !== 'undefined' &&
            SWPMMParams.customer.shipping_address
        ) {
          $('#countrySelect select').val(SWPMMParams.customer.shipping_address.country);
          var provinces = $('#countrySelect select').find('option:selected').data('provinces'),
              optionsAsString = '';

          if (!provinces.length) {
            $('#address_province').attr('disabled', 'disabled').html(defaultState);
            $('#address_province_container').hide();
          } else {
            for (var i = 0; i < provinces.length; i++) {
              optionsAsString += '<option value=\'' + provinces[i][0] + '\'>' + provinces[i][0] + '</option>';
            }
            $('#address_province').removeAttr('disabled').html(optionsAsString);
            if (SWPMMParams.customer.shipping_address.province) {
              $('#address_province').val(SWPMMParams.customer.shipping_address.province);
            }
          }
          if ($('#address_zip').val()) {
            $('.get-rates').trigger('click');
          }
        }

        $('#countrySelect select').on('change', function () {

          if ($('#countrySelect select').val() === 'United States') {
            self.checkVipShippingIs(true);
          } else {
            self.checkVipShippingIs(false);
          }

          if ($('#address_zip').val()) {
            $('.get-rates').trigger('click');
          }
          var provinces = $(this).find('option:selected').data('provinces'),
            optionsAsString = '';

          if (!provinces.length) {
            $('#address_province').attr('disabled', 'disabled').html(defaultState);
            return false;
          }
          for (var i = 0; i < provinces.length; i++) {
            optionsAsString += '<option value=\'' + provinces[i][0] + '\'>' + provinces[i][0] + '</option>';
          }
          $('#address_province').removeAttr('disabled').html(optionsAsString);
        });
        $('#address_zip').on('change', function () {
          if ($(this).val()) {
            setTimeout(function () { $('.get-rates').trigger('click');}, 100);
          }
        });
        $('#address_province').on('change', function () {
          if ($(this).val()) {
            setTimeout(function () { $('.get-rates').trigger('click');}, 100);
          }
        });
      }

      function appendShippingRate () {
        var vipIt = 0;
        var vipInt = setInterval(function () {
          if (++vipIt > 50) {
            clearInterval(vipInt);
          }
          if ($('#cartSubtotalValue').html()) {
            clearInterval(vipInt);
            $('.customer-cart-items .cart-subtotal').after('<div class=\'cart-shipping\'>Shipping: <span id=\'cartShippingValue\'>' + Shopify.formatMoney(0) + '</span></div>');
            window.vipPriceChanged();
          }
        }, 100);
      }

      function appendTaxRate () {
        var vipIt = 0;
        var vipInt = setInterval(function () {
          if (++vipIt > 50) {
            clearInterval(vipInt);
          }
          if ($('#cartSubtotalValue').html()) {
            clearInterval(vipInt);
            $('.customer-cart-items .cart-subtotal').after('<div class=\'cart-taxes\'>Taxes: <span id=\'cartTaxesValue\'>' + Shopify.formatMoney(0) + '</span></div>');
            window.vipPriceChanged();
          }
        }, 100);
      }

      function getUsedStoreCredits () {
        var response = $.ajax({
          type: 'GET',
          url: '/cart.json',
          success: function (data) {
            return data;
          },
          dataType: 'json',
          async: false
        }).responseText;
        return self.deleteMoneyFormat(JSON.parse(response).attributes['Used VIP Credits']);
      }

      function appendStoreCredits (storeCredits) {
        var vipIt = 0;
        var vipInt = setInterval(function () {
          if (++vipIt > 50) {
            clearInterval(vipInt);
          }
          if ($('#cartSubtotalValue').html()) {
            clearInterval(vipInt);
            $('.customer-cart-items .cart-subtotal').after('<div class=\'cart-credits\'>Store credits: <span id=\'cartCreditsValue\'>' + '-' + Shopify.formatMoney(storeCredits) + '</span></div>');
            window.vipPriceChanged();
          }
        }, 100);
      }

      function appendDiscount (amount) {
        var vipIt = 0;
        var vipInt = setInterval(function () {
          if (++vipIt > 50) {
            clearInterval(vipInt);
          }
          if ($('#cartSubtotalValue').html()) {
            clearInterval(vipInt);
            $('.customer-cart-items .cart-subtotal').after('<div class=\'cart-discount\'>Discount: <span id=\'cartDiscountValue\'>' + '-' + Shopify.formatMoney(amount) + '</span></div>');
            window.vipPriceChanged();
          }
        }, 100);
      }

      function createCustomOrder () {
        var html = self.getCheckoutData('/checkout');
        var cartItems = self.getCheckoutItem(html);
        var cartDiscount = self.getAvailableCartDiscount(html);
        var autoDiscountItems = [];
        if (typeof self.customer !== 'undefined' && typeof self.customer.id !== 'undefined' && self.customer.id !== null) {
          self.custom_order.customer = {
            'id': self.customer.id,
            'tags': self.customer.tags
          };
        }
        if (typeof SWPMMParams.cartSubtotal !== 'undefined') {
          self.custom_order.note_attributes = [{
            'name': 'Original subtotal',
            'value': SWPMMParams.cartSubtotal
          }];
        }

        self.custom_order.subtotal_price = 0;
        if (SWPMMParams.items.length) {
          self.custom_order.line_items = [];
          for (var cart_item in SWPMMParams.items) {
            if (!SWPMMParams.items.hasOwnProperty(cart_item)) {
              continue;
            }
            var data = {
              product_id: SWPMMParams.items[cart_item].product.id,
              variant_id: SWPMMParams.items[cart_item].id,
              quantity: SWPMMParams.items[cart_item].quantity
            };
            var disc = cartItems[data.variant_id].discount;
            data.price = SWPMMParams.items[cart_item].product.variant.price / 100;
            //change box type
            if (typeof Spurit.boxes !== 'undefined') {
              if (Spurit.boxes.boxProduct.vid === SWPMMParams.items[cart_item].id) {
                data.product_id = Spurit.boxes.boxVipProduct.id;
                data.variant_id = Spurit.boxes.boxVipProduct.vid;
              }
            }
            if ((!self.isBundleDiscount(SWPMMParams.items[cart_item].product) && self.isVipCollection(SWPMMParams.items[cart_item].product.handle)) || (!self.isBundleDiscount(SWPMMParams.items[cart_item].product) && self.isProductTagged(SWPMMParams.items[cart_item], SWPMMParams.items[cart_item].product_collections))) {
              self.customer.tagSettings = self.getTagSettings();
              if(!self.customer.hasVipOrder && SWPMMParams.items[cart_item].is_lowest_price_first_vip && parseInt(self.customer.tagSettings.first_discount)) {
                data.firstPrice = self.calcNewFirstPrice(SWPMMParams.items[cart_item].product.variant.price) / 100;
                data.price = self.calcNewPrice(SWPMMParams.items[cart_item].product.variant.price) / 100;
              } else {
                data.price = self.calcNewPrice(SWPMMParams.items[cart_item].product.variant.price) / 100;
              }
            }
            if (disc >= 0) {
              if (cartItems[data.variant_id].firstNewPrice !== -1) {
                if (autoDiscountItems.indexOf(data.variant_id) !== -1) {
                  data.price -= data.price * disc;
                } else {
                  autoDiscountItems.push(data.variant_id);
                }
              } else {
                data.price -= data.price * disc;
              }
            }
            if (typeof data.firstPrice !== 'undefined' && data.price) {
              self.custom_order.subtotal_price += data.firstPrice + data.price * (data.quantity-1);
            } else {
              self.custom_order.subtotal_price += data.price * data.quantity;
            }

            if (SWPMMParams.items[cart_item].properties.length) {
              data.properties = SWPMMParams.items[cart_item].properties;
            }
            if(!self.customer.hasVipOrder && SWPMMParams.items[cart_item].is_lowest_price_first_vip && parseInt(self.customer.tagSettings.first_discount)) {
              if (data.quantity > 1) {
                var firstSplitLineItem = Object.assign({}, data);
                firstSplitLineItem.price = self.calcNewFirstPrice(SWPMMParams.items[cart_item].product.variant.price) / 100;

                firstSplitLineItem.quantity = 1;
                data.quantity -= 1;
                if (data.quantity) {
                  firstSplitLineItem.splitItem = true;
                }
                self.custom_order.line_items.push(firstSplitLineItem);
              } else if (data.price) {
                data.price = self.calcNewFirstPrice(SWPMMParams.items[cart_item].product.variant.price) / 100;
              }
            }
            self.custom_order.line_items.push(data);
            if (!self.isContainGiftCardProduct) {
              self.isContainGiftCardProduct = SWPMMParams.items[cart_item].gift_card;
            }
          }
        }
        if (self.storeCredits && !self.isContainGiftCardProduct) {
          self.custom_order.note_attributes.push({
            name: Config.get('orderUsedCreditsAttribute'),
            value: (self.storeCredits / 100).toFixed(2)
          });
          self.custom_order.note_attributes.push({
            name: Config.get('orderBalanceCreditsAttribute'),
            value: self.getVipStoreCredits()
          });
        }
        if(!$.isEmptyObject(cartDiscount)) {
          if(self.isDiscountAvailable(cartDiscount.code) && self.custom_order.subtotal_price >= SWPMMParams.discountCodeThreshold/100) {
            self.custom_order.discount_codes = [{
              code: cartDiscount.code,
              amount: cartDiscount.amount / 100,
              type: "fixed_amount"
            }];
            self.cartDiscount = cartDiscount;
          }
        }

        Spurit.vipOrder = self.custom_order;
      }

      function populateItems () {
        var itemsData = '';
        var countSplitItems = 0;

        for (var line_item in self.custom_order.line_items) {
          if (!self.custom_order.line_items.hasOwnProperty(line_item)) {
            continue;
          }
          if (SWPMMParams.items[line_item-countSplitItems].product.tags.indexOf('vip-hidden-product') != -1) {
            continue;
          }
          itemsData += '<div class=\'vip-cart-item\'>';
          itemsData += '<div class=\'image-wrapper\'><div class=\'image-block\'><img src=\'' + SWPMMParams.items[line_item-countSplitItems].product.variant.image + '\' alt=\'\' class=\'product-image\' /></div>';
          itemsData += '<span class=\'product-quantity\'>' + self.custom_order.line_items[line_item].quantity + '</span></div>';
          itemsData += '<div class=\'product-desc\'><h4 class=\'product-title\'>' + SWPMMParams.items[line_item-countSplitItems].product.title + '</h4>';
          // for(var line_item in self.custom_order.line_items) {
          // SWPMMParams.items[line_item].product.title
          // }
          itemsData += /*'<span class=\'product-property\'>'++'</span>*/'</div>';
          itemsData += '<span class=\'product-total\'>' + Shopify.formatMoney(self.custom_order.line_items[line_item].price * self.custom_order.line_items[line_item].quantity * 100) + '</span>';
          itemsData += '</div>';
          if (self.custom_order.line_items[line_item].hasOwnProperty('splitItem')) {
            countSplitItems++;
          }
        }

        $('#vipCartItems').append(itemsData);
        $('#cartSubtotalValue').html(Shopify.formatMoney(self.custom_order.subtotal_price * 100));
        if (window.SWPMMParams.customer.tags.join().indexOf('vip_removed') >= 0) {
          $('.cart-subtotal').before('<div class="subscription">' +
            Config.get('customerVipSubscriptionLabel') + ':' +
            '<span id="cartSubscriptionValue">$' + Config.get('customerVipSubscriptionCost') + '.00</span>' +
            '</div>');
        }
        window.vipPriceChanged();
      }
    };

    var ProductPage = function () {
      var self = this;
      var showDiscount = true;
      var currentProduct = { id: null, vid: null };
      App.apply(this, arguments);//inherit app constructor
      this.init = function () {
        Config.init();
        this.setOptions();
        // this.initPriceUpdater();

        self.customer = SWPMMParams.customer;
        // if (this.customer.id){
        if (!this.isTaggedCustomer()) {
          return false;
        }
        // }else{
        //     this.showMessage();
        // }

        var form = $(Config.get('productForm')).first();
        if (!form.length) {
          return false;
        }

        this.subscribeOnVariantChange(form);
      };
      this.onVariantChangeCallback = function (form) {
        var selects = form.find(Config.get('variantSelect'));
        if (selects.length) {
          selects.on('change', function () {
            self.setVariant(form.find(Config.get('variantNativeSelect')).val());
            // setTimeout(function () {
            //     self.setVariant(form.find(Config.get('variantNativeSelect')).val());
            // },100);
          });
          selects.trigger('change');
        } else {
          // hidden input
          self.setVariant(form.find(Config.get('variantNativeSelect')).val());
        }

      };
      this.subscribeOnVariantChange = function (form) {
        if (Config.get('initTimeout')) {
          setTimeout(function () {
            self.onVariantChangeCallback(form);
          }, Config.get('initTimeout'));
        } else {
          $(window).load(function () {
            self.onVariantChangeCallback(form);
          });
        }
      };
      this.setVariant = function (vid) {
        this.currentProduct = {
          id: __st.rid,
          vid: vid,
          variant: this.getProductVariant(vid)
        };

        if (this.isProductDiscounted(this.currentProduct)) {
          this.showPrice(true);
        } else {
          this.showPrice();
        }
      };
      this.showPrice = function (showDiscount) {
        // if (this.customer.id){
        //     return false;
        // }

        if (!this.isVipCollection(this.getHandleFromUrl(window.location.href))) {
          return false;
        }

        var variant = this.currentProduct.variant;
        // var initialPrice = 0;

        if (!variant) {
          throw new Error('Variant is not found');
        }
        // if (typeof tagSettings !== 'undefined' && tagSettings.enable_calc_compare_at_price) {
        //   initialPrice = variant.compare_at_price;
        //   // if (!initialPrice) {
        //   //   initialPrice = variant.price;
        //   // }
        // } else {
        //   initialPrice = variant.price;
        // }

        // if ( showDiscount ) {//show or hide discounted price
        //     this.showDiscount = true;
        // } else {
        //     this.showDiscount = false;
        // }
        // Spurit.prices.recalculate('productPrice', initialPrice, function(){});
      };

      /**
       * Check if customer has a discount for the product
       */
      this.isProductDiscounted = function (product) {
        // let result = this.isAllowedProduct(product);
        // if ( !result ) {
        //     result = this.isAllowedCollection(SWPMMParams.product_collections);
        // }
        //

        return this.isProductTagged(product, SWPMMParams.product_collections);
      };

      this.getProductVariant = function (vid) {
        if (!vid) {
          return SWPMMParams.product.variants[0];
        }
        var vLength = SWPMMParams.product.variants.length;
        for (var i = 0; i < vLength; i++) {
          if (SWPMMParams.product.variants[i].id == vid) {
            return SWPMMParams.product.variants[i];
          }
        }

        return null;
      };

      // this.initPriceUpdater = function() {
      //     // callback called by Spurit.prices.recalculate trigger
      //     Spurit.prices.onChange(
      //         'productPrice', //price key = 1st param of the Spurit.prices.recalculate
      //         function (price, next) {
      //             var newPrice = price;
      //             if ( self.showDiscount ) {
      //                 newPrice = self.calcNewPrice(newPrice);
      //             }
      //             next(newPrice);
      //         },
      //         document.querySelector(Config.get('product_price')) //pass element
      //     );
      // };
    };

    var pausePage = function () {
      var self = this;
      this.chargeDate = null;
      this.customer = {};
      this.mainAction = '';
      this.pathToAction = [];
      this.isPause = false;
      this.config = {
        selectors: {
          mainMenuBlock: '.manage-my-membership__main-menu',
          pauseBlock: '.manage-my-membership__pause',
          resultBlock: '.manage-my-membership__result',
          feedbackBlock: '.manage-my-membership__feedback',
          perksBlock: '.manage-my-membership__perk-page',
          cancelCouponBlock: '.manage-my-membership__cancel-coupon',
          cancelBlock: '.manage-my-membership__cancel',
          pauseInput: '[id^="pause_menu_item"]',
          mainMenuInput: '[id^="Main_menu_item"]',
          cancelInput: '[id^="reason_cancel"]',
          currentBLock: '.manage-my-membership__block:not(.hide)',
          showCancelCheckbox: '#show-cancel',
          cancelOptions: '.manage-my-membership__cancel-items'
        },
        ids: {
          pauseButton: 'pause-button',
          resumeButton: 'resume-button',
          mainMenuButton: 'main-menu-button',
          continueCancelButton: 'continue-cancel-button',
          cancelButton: 'cancel-button',
          claimOfferButton: 'claim-offer',
          campaignSettings: 'google-utm-settings',
          backLink: 'back-from-membership'
        }
      };
      App.apply(this, arguments);//inherit app constructor
      Config.init();
      var customerId = SWPMMParams.customer.id;
      if (!customerId)
        throw new Error('Customer ID can not be empty');

      this.init = function () {
        this.apiUrl = Config.get('apiUrl');
        this.pauseButton = document.getElementById(this.config.ids.pauseButton);
        this.resumeButton = document.getElementById(this.config.ids.resumeButton);
        this.mainMenuButton = document.getElementById(this.config.ids.mainMenuButton);
        this.continueCancelButton = document.getElementById(this.config.ids.continueCancelButton);
        this.cancelButton = document.getElementById(this.config.ids.cancelButton);
        this.claimOfferButton = document.getElementById(this.config.ids.claimOfferButton);
        this.campaignSettings = document.getElementById(this.config.ids.campaignSettings);
        this.mainMenuBlock = document.querySelector(this.config.selectors.mainMenuBlock);
        this.pauseBlock = document.querySelector(this.config.selectors.pauseBlock);
        this.resultBlock = document.querySelector(this.config.selectors.resultBlock);
        this.feedbackBlock = document.querySelector(this.config.selectors.feedbackBlock);
        this.perksBlock = document.querySelector(this.config.selectors.perksBlock);
        this.cancelBlock = document.querySelector(this.config.selectors.cancelBlock);
        this.cancelCouponBlock = document.querySelector(this.config.selectors.cancelCouponBlock);
        this.cancelOptions = document.querySelector(this.config.selectors.cancelOptions);
        this.backLink = document.getElementById(this.config.ids.backLink);

        this.customer = {
          id: customerId,
          email: SWPMMParams.customer.email,
          firstName: SWPMMParams.customer.first_name,
          lastName: SWPMMParams.customer.first_name
        };
        let pauseItems = document.querySelectorAll(this.config.selectors.pauseInput),
          mainMenuItems = document.querySelectorAll(this.config.selectors.mainMenuInput),
          cancelInputs = document.querySelectorAll(this.config.selectors.cancelInput),
          showCancel = document.querySelector(this.config.selectors.showCancelCheckbox);
        pauseItems.forEach(function (input) {
          input.addEventListener('click', self.pauseInputHandler);
        });
        mainMenuItems.forEach(function (input) {
          input.addEventListener('click', self.activateMainMenuButton);
        });
        cancelInputs.forEach(function (input) {
          input.addEventListener('click', self.cancelInputHandler);
        });
        showCancel.addEventListener('change', self.showCancelButton);
        this.pauseButton.addEventListener('click', this.pauseHandler);
        this.resumeButton.addEventListener('click', this.resumeHandler);
        this.mainMenuButton.addEventListener('click', this.mainMenuHandler);
        this.continueCancelButton.addEventListener('click', this.continueCancelHandler);
        this.cancelButton.addEventListener('click', this.cancelHandler);
        if (this.claimOfferButton) {
          this.claimOfferButton.addEventListener('click', this.claimOfferHandler);
        }
        self.isPause = !this.resultBlock.classList.contains('hide');
        window.onhashchange = this.hashHandler;
        if (__st.p) {
          $('body').addClass('no-scroll');
          $('#vipOrderLoading').addClass('is-active');
        }
        $(window).on('load', function () {
          $('#back-from-membership,#mobile-back-from-membership').on('click', function (e) {
            history.back();
          });
        });
        this.loadingEnd();
        this.hashHandler();
      };

      this.hashHandler = function (event) {
        let hash = window.location.hash.substr(1);
        let currentBlock = document.querySelector(self.config.selectors.currentBLock);
        currentBlock.classList.add('hide');
        self.backLink.querySelector('span').innerHTML = '< Previous Page';
        switch (hash) {
          case 'pause':
            self.pauseBlock.classList.remove('hide');
            break;
          case 'pauseCancel':
            self.pauseBlock.classList.remove('hide');
            self.pauseBlock.querySelector('[href="#cancel"]').classList.remove('hide');
            self.pathToAction.push('Pause membership');
            break;
          case 'feedback':
            self.feedbackBlock.classList.remove('hide');
            break;
          case 'perk':
            self.perksBlock.classList.remove('hide');
            self.pathToAction.push('Perks Reminder');
            break;
          case 'cancel':
            self.cancelCouponBlock.classList.remove('hide');
            break;
          case 'cancelOption':
            self.shuffleList(self.cancelOptions);
            self.cancelBlock.classList.remove('hide');
            break;
          default:
            self.backLink.querySelector('span').innerHTML = '< Back to My Account';
            if (self.isPause) {
              self.resultBlock.classList.remove('hide');
            } else {
              self.mainMenuBlock.classList.remove('hide');
            }
        }
        window.scrollTo(0, 0);
      };

      this.shuffleList = function (list) {
        for (let i = list.children.length; i >= 0; i--) {
          list.appendChild(list.children[Math.random() * i | 0]);
        }
      };

      this.getCampaignSettings = function () {
        return {
          'utm_source': this.campaignSettings.dataset.source,
          'utm_medium': this.campaignSettings.dataset.medium,
          'utm_name': this.campaignSettings.dataset.name
        };
      };

      this.getUrlWithUtmCodes = function (url, content) {
        let settingsAtributes = '';
        let campaignSettings = this.getCampaignSettings();
        for (let key in campaignSettings) {
          let separator = settingsAtributes ? '&' : '';
          settingsAtributes += separator + key + '=' + campaignSettings[key];
        }
        return url + '?' + settingsAtributes + '&utm_content=' + content;
      };

      this.formatPath = function (pathToAction) {
        return pathToAction.map(function (item, index) {
          return index + 1 + '.' + item;
        });
      };

      this.getPathString = function () {
        return this.formatPath(self.pathToAction).toString();
      };

      this.activateMainMenuButton = function (event) {
        self.mainMenuButton.removeAttribute('disabled');
        self.mainMenuButton.dataset.redirect = this.dataset.redirect;
        self.mainAction = this.dataset.type;
      };

      this.pauseInputHandler = function (event) {
        self.pauseButton.removeAttribute('disabled');
        self.pauseButton.dataset.pause = event.target.value;
      };

      this.cancelInputHandler = function (event) {
        self.continueCancelButton.removeAttribute('disabled');
        self.continueCancelButton.dataset.redirect = this.dataset.redirect;
        self.continueCancelButton.dataset.type = this.dataset.type;
        self.continueCancelButton.dataset.title = this.dataset.title;
      };

      this.continueCancelHandler = function (event) {
        window.location.href = this.dataset.redirect;
        self.pathToAction.push(this.dataset.title);
        if (this.dataset.type === 'redirect') {
          self.loadingStart();
        }
      };

      this.cancelHandler = function (event) {
        self.pathToAction.push('Cancel');
        let targetElement = this;
        self.loadingStart(targetElement);
        let pathToAction = self.getPathString();
        let request = {
          customer: self.customer,
          pathToAction: pathToAction
        };
        $.ajax({
          url: self.apiUrl + '/checkout/unsubscribe',
          dataType: 'json',
          type: 'post',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          contentType: 'application/json',
          data: JSON.stringify(request),
          processData: false,
          success: function (data, textStatus, jQxhr) {
            window.location.href = self.getUrlWithUtmCodes('/account#cancelSubscription', pathToAction);
          },
          error: function (jqXHR, exception) {
            Spurit.showAlert(jqXHR.responseJSON.error);
            self.loadingEnd(targetElement);
          }
        });
      };

      this.showCancelButton = function () {
        if (this.checked) {
          self.cancelButton.classList.remove('hide');
        } else {
          self.cancelButton.classList.add('hide');
        }
      };

      this.claimOfferHandler = function (event) {
        let targetElement = this;
        self.pathToAction.push('Claim offer');
        self.loadingStart(targetElement);
        let pathToAction = self.getPathString();
        let request = {
          customer: self.customer,
          pathToAction: pathToAction
        };
        $.ajax({
          url: self.apiUrl + '/checkout/claimOffer',
          dataType: 'json',
          type: 'post',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          contentType: 'application/json',
          data: JSON.stringify(request),
          processData: false,
          success: function (data, textStatus, jQxhr) {
            window.location.href = self.getUrlWithUtmCodes('/account#claimOffer', pathToAction);
          },
          error: function (jqXHR, exception) {
            Spurit.showAlert(jqXHR.responseJSON.error);
            self.loadingEnd(targetElement);
          }
        });
      };

      this.mainMenuHandler = function () {
        window.location.href = this.dataset.redirect;
        if (this.dataset.type === 'redirect') {
          self.loadingStart();
        }
      };

      this.resumeHandler = function (event) {
        let targetElement = this;
        self.pathToAction.length = 0;
        self.loadingStart(targetElement);
        let request = {
          customer: self.customer
        };
        $.ajax({
          url: self.apiUrl + '/checkout/resumePause',
          dataType: 'json',
          type: 'post',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          contentType: 'application/json',
          data: JSON.stringify(request),
          processData: false,
          success: function (data, textStatus, jQxhr) {
            self.loadingEnd(targetElement);
            window.location.href = '/account#resumePause';
          },
          error: function (jqXHR, exception) {
            Spurit.showAlert(jqXHR.responseJSON.error);
            self.loadingEnd(targetElement);
          }
        });
      };

      this.pauseHandler = function (event) {
        let targetElement = this;
        self.loadingStart(targetElement);
        self.pathToAction.push('Pause');
        let pause = parseInt(event.target.dataset.pause);
        let pathToAction = self.getPathString();
        self.setChargeDate(pause);
        let request = {
          customer: self.customer,
          pause: pause,
          chargeDate: self.chargeDate,
          pathToAction: pathToAction
        };
        $.ajax({
          url: self.apiUrl + '/checkout/pauseSubscription',
          dataType: 'json',
          type: 'post',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          contentType: 'application/json',
          data: JSON.stringify(request),
          processData: false,
          success: function (data, textStatus, jQxhr) {
            history.replaceState(null, '', '/account');
            window.location.href = self.getUrlWithUtmCodes('/pages/manage-my-membership', pathToAction);
          },
          error: function (jqXHR, exception) {
            self.loadingEnd(targetElement);
            Spurit.showAlert(jqXHR.responseJSON.error);
          }
        });
      };

      this.setResultData = function (data) {
        let countMonthStr = data.pausePeriods === 1 ? ' month' : ' months';
        this.resultBlock.querySelector('h2 > span').innerHTML = ' ' + data.pausePeriods + ' ' + countMonthStr;
        this.resultBlock.querySelector('h2 + p').innerHTML = this.resultBlock.querySelector('h2 + p').innerHTML + ' ' + data.endPause;
      };

      this.setChargeDate = function (pause) {
        let currentDate = new Date();
        let chargeDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + pause + 1, 1);
        let chargeMonth = chargeDate.toLocaleString('en-EN', { month: 'long', day: 'numeric' });
        self.chargeDate = chargeMonth;
      };
    };

    var editCustomer = function () {
      var self = this;
      Config.init();
      this.getInterestArray = function (object) {
        var arr = [];
        for (const prop in object) {
          if (prop.indexOf('interest_') + 1)
            arr[arr.length] = object[prop];
        }
        return arr;
      };

      this.convertPhoneNumber = function (customer) {
        console.log(customer);
        let phone = customer.phone;
        if (customer.country === 'Canada' || customer.country === 'United States') {
          if (/\+1/.exec(phone)) {

          } else if (/^1/.exec(phone)) {
            phone = '+' + phone;
          } else {
            phone = '+1' + phone;
          }
        }
        return phone;
      };

      var $form = $('#update-customer-form');
      if (!$form.length)
        throw new Error('Container was not found');
      $form.on('submit', function (event) {
        event.preventDefault();
        var _learnq = window._learnq || [];
        var formData = $(event.target).serializeObject();
        formData.customer.phone = Spurit.iti.getNumber();
        var apiUrl = Config.get('apiUrl');
        var interestArray = self.getInterestArray(formData.customer.note);
        $.ajax({
          type: 'POST',
          url: apiUrl + '/checkout/editCustomer',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          data: JSON.stringify(formData),
          processData: false,
          success: function (e) {
            _learnq.push(['identify', {
              '$email': formData.customer.static_email,
              '$phone_number': formData.customer.phone,
              '$Date Of Birth': formData.customer.note.date_of_birth,
              '$Interest in': interestArray
            }]);
            window.location.href = '/account?view=confirm-update';
          },
          error: function (xhr, ajaxOptions, thrownError) {
            Spurit.showAlert(xhr.responseJSON.error);
          },
          dataType: 'json',
          contentType: 'application/json'
        });
      });
    };

    var cardDetailsPage = function () {
      Config.init();
      var customerId = SWPMMParams.customer.id;
      if (!customerId)
        throw new Error('Customer ID can not be empty');

      var $form = $('#update-card-details-form');
      if (!$form.length)
        throw new Error('Container was not found');

      loadScript('https://js.braintreegateway.com/web/dropin/1.22.0/js/dropin.min.js', function () {
        var apiUrl = Config.get('apiUrl');
        var debugString = Config.get('debugString') || '';
        $.ajax({
          url: apiUrl + '/checkout/token' + debugString,
          dataType: 'json',
          headers: { 'X-Store-Hash': Config.getHash() },
          success: function (res) {
            if (!res.token)
              return Spurit.showAlert('Error: Payment gateway token was not received');

            braintree.dropin.create({
              authorization: res.token,
              selector: '#bt-dropin',
              card: {
                overrides: {
                  styles: {
                    '#credit-card-number::placeholder': {
                      'font-size': '24px'
                    },
                    '#cvv::placeholder': {
                      'font-size': '24px'
                    }
                  }
                }
              }
            }, function (createErr, instance) {
              if (createErr)
                return Spurit.showAlert('Error: Payment gateway was not initialized properly');

              $form.on('submit', function (event) {
                event.preventDefault();
                $('#update-card-details-form [type="submit"]').prop('disabled', true);
                instance.requestPaymentMethod(function (err, payload) {
                  if (err) {
                    return Spurit.showAlert('Error: Credit card validation failed' + err.message);
                    $('#update-card-details-form [type="submit"]').prop('disabled', false);
                  }
                  var request = {
                    nonce: payload.nonce,
                    customer: {
                      id: customerId,
                      email: SWPMMParams.customer.email,
                      firstName: SWPMMParams.customer.first_name,
                      lastName: SWPMMParams.customer.first_name
                    }
                  };
                  $.ajax({
                    url: apiUrl + '/checkout/updateCardDetails' + debugString,
                    dataType: 'json',
                    type: 'post',
                    headers: {
                      'X-Store-Hash': Config.getHash()
                    },
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    processData: false,
                    success: function (data, textStatus, jQxhr) {
                      window.location.href = '/account/?view=confirm-card-update';
                    },
                    error: function () {
                      Spurit.showAlert('Credit card information was not updated');
                      $('#update-card-details-form [type="submit"]').prop('disabled', false);
                    }
                  });
                });
              });
            });
          }
        });
      });
    };

    var priceUpdater = function () {
      var self = this;
      App.apply(this, arguments);//inherit app constructor

      Spurit.elementsDiscounted = [];
      var srt_i = 0;

      this.init = function () {
        this.customer = SWPMMParams.customer;
        if (Config.getCookie('disable_vip_app')) return;
        if ($.isEmptyObject(SWPMMParams.productsWithCollections) && currentPage === 'collection') {
          jQuery.ajax({
            url: window.location.pathname + '?view=productsWithCollections',
            success: function (result) {
              SWPMMParams.productsWithCollections = JSON.parse(result);
            },
            async: false
          });
        }
        this.isTaggedCustomer();
        if(currentPage === "custom" && SWPMMParams.scriptId === '109576255') {
          console.log('change discount');
          if(SWPMMParams.itemsCount >= 10) {
            this.customer.tagSettings.discount = "60.00";
          }
        }
        Config.init();
        this.setOptions();

        var elements = document.querySelectorAll(Config.get('productPricesSelector'));

        if (!elements.length) {
          return false;
        }
        if (!Spurit.elementsDiscounted.length) {
          srt_i++;
        }

        for (var key = 0; key < elements.length; ++key) {
          if (Spurit.elementsDiscounted.includes(key)) {
            continue;
          }
          Spurit.elementsDiscounted.push(key);

          var callback = function(price, next) {
            next(self.calcNewPrice(price));
          }

          var callbackFirst = function(price, next) {
            next(self.calcNewFirstPrice(price));
          }

          if (self.isBundleDiscountProduct(elements[key])) {
            callback = function(price, next) {
              var bundlePrice = 8000;
              next(bundlePrice);
            }
          }

          Spurit.prices.onChange(
            'productPrice' + srt_i + '_' + key, //price key = 1st param of the Spurit.prices.recalculate
            callback,
            elements[key] //pass element
          );

          var url = $(elements[key]).parents('.ProductItem').find('a').attr('href');
          if (typeof url === 'undefined') {
            url = window.location.href;
          }

          var handle = this.getHandleFromUrl(url);
          var isFirstVipTag = this.isFirstVipTag(handle);

          if(!this.customer.hasVipOrder && isFirstVipTag && parseInt(self.customer.tagSettings.first_discount)) {
            Spurit.prices.onChange(
              'productPriceFirst' + srt_i + '_' + key, //price key = 1st param of the Spurit.prices.recalculate
              callbackFirst,
              elements[key] //pass element
            );
          }

          // var initialPrice = parseFloat(elements[key].innerHTML.replace(/\$|,/g, ''), 10)*100;
          var initialPrice = this.getProductPrice(handle);

          if (!this.isVipCollection(handle)) {
            continue;
          }

          Spurit.prices.recalculate('productPrice' + srt_i + '_' + key, initialPrice, function (newPrice, elements) { /*callback*/
            elements.forEach(function (el) {
              var newPriceElement = el.parentElement.querySelector('.sp-price');
              newPriceElement.append(' VIP');
              newPriceElement.classList.remove('sp-price');
            });
          });
          if(!this.customer.hasVipOrder && isFirstVipTag && parseInt(self.customer.tagSettings.first_discount)) {
            Spurit.prices.recalculate('productPriceFirst' + srt_i + '_' + key, initialPrice, function (newPrice, elements) { /*callback*/
              elements.forEach(function (el) {
                var newPriceElement = el.parentElement.querySelector('.sp-price');
                newPriceElement.append(Config.get('firstVipPricePostfix'));
              });
            });
          }
        }
      };
    };

    var currentPage = (function () {
      var pageName = null;
      if (__st.p) {
        pageName = __st.p;
      } else {
        if (window.location.hostname == 'checkout.shopify.com' || window.location.pathname.indexOf('/orders/') !== -1) {
          pageName = 'checkout';
        } else if (window.location.pathname.indexOf('/cart') === 0) {
          pageName = 'cart';
        }
      }
      if (window.location.pathname.indexOf('/pages/card-details') !== -1 || window.location.search.indexOf('?view=my-cards') !== -1 || window.location.search.indexOf('?view=subscribe') !== -1) {
        pageName = 'card';
      } else if (window.location.pathname.indexOf('/pages/manage-my-membership') === 0) {
        pageName = 'pause';
      } else if (window.location.pathname.indexOf('/account') === 0 && window.location.search.indexOf('?view=edit-information') !== -1) {
        pageName = 'edit-customer';
      }
      if (window.location.pathname.indexOf('/pages/checkout') !== -1) {
        pageName = 'custom';
      }

      return pageName;
    })();

    var initApp = function () {
      var priceUpdaterObj = new priceUpdater();
      var appObj = new App();
      appObj.checkGoogleFeed();
      switch (currentPage) {
        case 'product':
          new ProductPage().init();
          Config.set('firstVipPricePostfix',' First VIP Gel');
          priceUpdaterObj.init();
          break;
        case 'cart':
          Config.set('firstVipPricePostfix',' First VIP Gel');
          new CartPage().init();
          break;
        case 'card':
          cardDetailsPage();
          break;
        case 'pause':
          new pausePage().init();
          break;
        case 'edit-customer':
          new editCustomer();
          break;
        default:
          appObj.init();
          priceUpdaterObj.init();
          Spurit.recalculatePrices = function () {
            priceUpdaterObj.init();
          };
      }

      if (window.location.pathname === Config.get('vipCheckoutPageUrl')) {
        window.setShippingRates = function (data) {
          window.shippingRates = data;

          var vipIt = 0;
          var vipInt = setInterval(function () {
            if (++vipIt > 100) {
              clearInterval(vipInt);
            }
            if ($('#shipping-rates input').length) {
              clearInterval(vipInt);

              $('body').on('change', $('#shipping-rates input'), function () {
                var shippingRate = window.shippingRates[$('#shipping-rates input:checked').data('i')];
                if (typeof shippingRate === 'undefined') {
                  //Spurit.showAlert('Shipping method is a required field');
                  return false;
                }
                $('#cartShippingValue').html(shippingRate.price);
                window.vipPriceChanged();
              });

              $('#shipping-rates input').trigger('change');
            }
          }, 50);
        };
        new VipCheckoutPage().init();
      }
    };

    var pathToScriptPrices = Config.get('s3SharedPrefix') + '/js/spurit.prices.min.js';
    var linkScript = document.querySelector('#spurit-prices');
    if (linkScript) {
      pathToScriptPrices = linkScript.getAttribute('href');
    }
    loadScript(Config.get('folderStore') + Config.get('id') + '.js?' + Math.random(), function () {
      //loadScript(Config.get('s3Prefix') + '/js/jquery.spur.cart.api.js', function(){// Including api.jquery.js
      loadScript(pathToScriptPrices, function () {
        loadScript(Config.get('s3SharedPrefix') + '/js/spurit.checkout.min.js', function () {
          initApp();
        });
      });
      //});
    });
  };

  // Selector Picker
  if (document.location.search.indexOf(selectorPicker.cmd) !== -1) {
    var AjaxCart = (function () {//responsible for Shopify Cart API calls

      return {
        post: function (url, data, callback) {
          $.ajax({
            type: 'POST',
            url: url,
            cache: false,
            dataType: 'json',
            data: data
          }).done(function (data) {
            if (typeof callback === 'function') callback(data);
          }).fail(function (err) {
            try {
              var desc = JSON.parse(err.responseText).description;
              if (desc.length) {
                app.loader(false);
                alert(desc);
              }
            } catch (e) {
            }
          });
        },
        addItem: function (itemData, callback) {
          AjaxCart.post('/cart/add.js', itemData, function (data) {
            if (typeof callback === 'function') callback(data);
          });
        },
        clear: function (callback) {
          AjaxCart.post('/cart/clear.js', {}, function (data) {
            if (typeof callback === 'function') callback(data);
          });
        }
      };
    })();

    loadScript(selectorPicker.url, function () {
      if (typeof (SWPMMParams.items) !== 'undefined') {
        var getParams = window.location.search.replace('?', '').split('&').reduce(
          function (p, e) {
            var a = e.split('=');
            p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
            return p;
          },
          {}
        );
        if (typeof (getParams.vid) !== 'undefined' && SWPMMParams.items.length != 1) {
          AjaxCart.clear(function () {
            AjaxCart.addItem({ 'quantity': 1, 'id': getParams.vid }, function () {
              document.location.reload();
            });
          });
        }
      }
    });
    return;
  }

  try {
    if ((typeof jQuery === 'undefined') || (versionCompare('2.0', jQuery.fn.jquery))) {
      var doNoConflict = true;
      if (typeof jQuery === 'undefined') {
        doNoConflict = false;
      }
      loadScript('//ajax.googleapis.com/ajax/libs/jquery/2.1.4/jquery.min.js', function () {
        if (doNoConflict) {
          jQuery17 = jQuery.noConflict(true);
        } else {
          jQuery17 = jQuery;
        }
        main(jQuery17, jQuery);
      });
    } else {
      main(jQuery, jQuery);
    }
  } catch (e) {
    console.log('Wholesale Prices Membership Manager app exception: ' + e);
  }

})();
